/* DK product pages (sections/mys-pdp-*.liquid, _qa/product/spec.md §5.10). One IIFE, no dependencies.
   Parts: variants, gallery, goto, moduleGlue (booth pages -> the shared booking module), dated, add, sticky,
   related quick add, about collapse. Every part bails out silently when its DOM is absent.
   Contracts kept: sessionStorage wdn_bookingdate (DD/MM/YYYY), document events myselfie:date / myselfie:cart /
   cart:refresh, Ajax Cart API only (/cart/add.js -> Shopify's product_added_to_cart), api-dates.js untouched.
   Booth prices depend on the date (owner 2026-10-04): without a date the hero shows "fra <lowest price the booking
   module can sell this duration/configuration for>"; with a date (the module's, else the cart's) the exact price for
   that date. Server-rendered by sections/mys-pdp-main.liquid (snippets/mys-pdp-date-price.liquid), then followed
   here (renderPrice). The JSON-LD keeps the variant prices. Lease months and other products: the variant price.
   Season pricing (_qa/seasons/spec.md): a product with a "Sæson" option never shows that option, never writes
   ?variant= to the address bar (an incoming one is read for the other options, then removed), and the season always
   comes from the date (assets/myselfie-seasons.js) - an incoming ?variant= only keeps its own price on the first
   paint while no date is known (Google Shopping price match). */
(function () {
  'use strict';

  var root = document.querySelector('[data-pdp]');
  if (!root || root.__mysPdp) return;
  root.__mysPdp = true;

  var ROOT = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');
  var KIND = root.getAttribute('data-kind') || '';
  var IS_BOOTH = KIND.indexOf('booth') === 0;
  var IS_BUNDLE = root.hasAttribute('data-bundle'); // Myselfie + Print / Premium / Mygreetings (_qa/bundles/plan.md)
  // season bundle (Varighed x Season, owner 2026-10-08): sold whole from the buy box, no booking module on the page
  var IS_WHOLE = IS_BUNDLE && root.hasAttribute('data-whole');
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var form = root.querySelector('[data-pdp-form]');
  var idInput = root.querySelector('[data-pdp-variant]');
  var variants = [];
  try { variants = JSON.parse((root.querySelector('[data-pdp-variants]') || {}).textContent || '[]'); } catch (e) { variants = []; }
  var current = null;
  for (var vi = 0; vi < variants.length; vi++) if (idInput && String(variants[vi].id) === idInput.value) current = variants[vi];
  if (!current) current = variants[0] || null;

  function all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function noop() {}
  /** "myselfie:cart" detail: KIT.cartDetail (assets/myselfie-checkout.js); paid_count = lines that cost money. */
  function cartDetail(cart) {
    var kit = window.myselfie && window.myselfie.checkoutKit;
    if (kit && kit.cartDetail) return kit.cartDetail(cart);
    var paid = (cart.items || []).reduce(function (n, it) { return n + ((it.final_line_price != null ? it.final_line_price : it.line_price) > 0 ? it.quantity : 0); }, 0);
    return { item_count: cart.item_count, items_subtotal_price: cart.items_subtotal_price, paid_count: paid, cart: cart };
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function displayToIso(s) {
    var m = String(s || '').match(/^(\d{1,2})[/-](\d{1,2})[/-](\d{4})$/);
    return m ? m[3] + '-' + pad(+m[2]) + '-' + pad(+m[1]) : '';
  }
  function isoToShort(iso) { var p = String(iso).split('-'); return p.length === 3 ? p[2] + '/' + p[1] : iso; }
  /** i18n: window.myselfie.i18n.<ns>.<key> (snippets/myselfie-i18n-*.liquid), else the Danish fallback; [var] placeholders */
  function tx(ns, key, fallback, vars) {
    var s = window.myselfie && window.myselfie.i18n && window.myselfie.i18n[ns] && window.myselfie.i18n[ns][key];
    if (s == null || s === '') s = fallback;
    if (vars) for (var k in vars) s = String(s).split('[' + k + ']').join(vars[k]);
    return s;
  }
  function numLocale() { return tx('common', 'number_locale', 'da-DK'); }
  /** amount -> the store's number format (da-DK "1.499" / "1.499,00", sv-SE "1 499"); digits = fixed decimals */
  function fmtNum(amount, digits) {
    try {
      return Number(amount).toLocaleString(numLocale(), { minimumFractionDigits: digits, maximumFractionDigits: digits });
    } catch (e) {
      var whole = Math.floor(amount);
      var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return digits ? s + ',' + pad(Math.round((amount - whole) * 100)) : s;
    }
  }
  /** øre -> "1.499 kr" / "14,95 kr" (same output as Liquid money_without_trailing_zeros in this shop); SE "1 499 kr" */
  function fmt(ore) {
    ore = Math.round(+ore || 0);
    var rest = ore % 100;
    return tx('common', 'money', '[amount] kr', { amount: fmtNum(ore / 100, rest ? 2 : 0) });
  }
  /* SKU grammar (identical in every store): booth M-W / M-1 / M-2 / M-7, lease M-93 / M-185 / M-365 / M-730;
     print bundles …+MYP-<n>-<P|S>-<ML|NL|EL> (n × 400 prints, P = Polaroid, S = strip; logo Myselfie / none / own). */
  /** Booth duration code of a SKU: 'W', '1', '2', '7', '93' … ('' = not a booth SKU) */
  function boothCode(sku) {
    var m = /^M-(W|\d+)(?=$|[+\-\s])/i.exec(String(sku || '').trim());
    return m ? m[1].toUpperCase() : '';
  }
  function isLeaseCode(c) { return /^\d+$/.test(c) && +c > 7; }
  /** {prints, type: 'P'|'S'|'', logo: 'ML'|'NL'|'EL'|''} from a MYP-… SKU part, null without one */
  function bundleSku(sku) {
    var m = /(?:^|\+)MYP-(\d+)(?:-([PS]))?(?:-(ML|NL|EL))?(?=$|[+\s])/i.exec(String(sku || '').trim());
    return m ? { prints: (+m[1] || 1) * 400, type: (m[2] || '').toUpperCase(), logo: (m[3] || '').toUpperCase() } : null;
  }
  /** "Fotostribe" / "Strip" / "Fotoremsa" / "Streifen" -> 'S', "Polaroid" -> 'P' */
  function printKeyOf(value) {
    var s = String(value || '');
    if (/polaroid/i.test(s)) return 'P';
    if (/strip|stribe|remsa|streifen/i.test(s)) return 'S';
    return '';
  }
  /** Logo code of an option text: own / none / Myselfie (any store language) */
  function logoCodeOfText(text) {
    var s = String(text || '');
    if (/eget|egen|eigen|own/i.test(s)) return 'EL';
    if (/ingen|kein|no logo|none/i.test(s)) return 'NL';
    return 'ML';
  }
  function headerOffset() {
    var bar = document.querySelector('.Navigation') || document.querySelector('[data-mys-nav]');
    var b = bar ? bar.getBoundingClientRect().bottom : 0;
    return Math.max(0, b) + 16;
  }
  function scrollToEl(el) {
    var y = el.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop) - headerOffset();
    window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: reduceMotion ? 'auto' : 'smooth' });
  }
  function focusQuietly(el) {
    if (!el) return;
    if (!el.matches('a[href], button, input, select, textarea, [tabindex]')) el.setAttribute('tabindex', '-1');
    try { el.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
  }
  var OPTION_NAMES = [];
  try { OPTION_NAMES = JSON.parse(root.getAttribute('data-option-names') || '[]'); } catch (e) { OPTION_NAMES = []; }
  var SK = function () { return window.myselfie && window.myselfie.seasonKit; };
  /** Index of the "Sæson" option (-1 = none). Same names as assets/myselfie-seasons.js. */
  var SEASON_IDX = (function () {
    for (var i = 0; i < OPTION_NAMES.length; i++) {
      var n = String(OPTION_NAMES[i]).toLowerCase().replace(/æ/g, 'ae').replace(/[äå]/g, 'a').replace(/[\s_\-.]+/g, '');
      if (n === 'saeson' || n === 'season' || n === 'sasong' || n === 'saison') return i;
    }
    return -1;
  })();
  var SEASONAL = SEASON_IDX > -1;
  /** Rental period option names in every store language ("Varighed", "Hyresperiod", "Mietdauer" …). */
  var DUR_NAME = /varighed|hyres?period|hyrperiod|lejeperiode|mietdauer|mietzeit|duration|rental period/i;
  function valuesOf(i) {
    var out = [];
    variants.forEach(function (v) { var o = v.options[i]; if (o != null && out.indexOf(o) < 0) out.push(o); });
    return out;
  }
  /** Index of the rental period option (-1 = none): the option the booth SKUs' duration codes (M-W, M-1 …) follow
      (as snippets/mys-pdp-dur-index.liquid), else by its name in any store language; without option names the first
      chip group's legend. */
  var DUR_IDX = (function () {
    var i;
    if (OPTION_NAMES.length) {
      var bySku = variants.length > 1 && variants.every(function (v) { return boothCode(v.sku); });
      for (i = 0; bySku && i < OPTION_NAMES.length; i++) {
        if (i === SEASON_IDX) continue;
        var map = {};
        var codes = [];
        var ok = variants.every(function (v) {
          var c = boothCode(v.sku);
          var o = String(v.options[i]);
          if (map[o] && map[o] !== c) return false;
          map[o] = c;
          if (codes.indexOf(c) < 0) codes.push(c);
          return true;
        });
        if (ok && codes.length > 1) return i;
      }
      for (i = 0; i < OPTION_NAMES.length; i++) if (i !== SEASON_IDX && DUR_NAME.test(OPTION_NAMES[i])) return i;
      return -1;
    }
    var legend = root.querySelector('[data-pdp-opt="0"] .mys-pdp__opt-label');
    return legend && DUR_NAME.test(legend.textContent) ? 0 : -1;
  })();
  /** Print type / logo / prints options (bundles), found by their values or names in any store language. */
  var PT_IDX = (function () {
    for (var i = 0; i < OPTION_NAMES.length; i++) if (i !== SEASON_IDX && /print ?type/i.test(OPTION_NAMES[i])) return i;
    for (i = 0; i < OPTION_NAMES.length; i++) {
      if (i === SEASON_IDX) continue;
      var vals = valuesOf(i);
      if (vals.length && vals.every(function (x) { return /^(polaroid|(foto|photo)?\s?(strip|stribe|remsa|streifen))/i.test(String(x)); })) return i;
    }
    return -1;
  })();
  var LOGO_IDX = (function () {
    for (var i = 0; i < OPTION_NAMES.length; i++) if (i !== SEASON_IDX && i !== PT_IDX && /logo|logga/i.test(OPTION_NAMES[i])) return i;
    return -1;
  })();
  var PRINTS_IDX = (function () {
    for (var i = 0; i < OPTION_NAMES.length; i++) {
      if (i === SEASON_IDX || i === PT_IDX || i === LOGO_IDX || i === DUR_IDX) continue;
      if (/prints|utskrift|drucke|anzahl|antal/i.test(OPTION_NAMES[i])) return i;
    }
    return -1;
  })();
  /** Print type shown on the variant (its option value, else from the SKU: Polaroid / Strip) */
  function printTypeOf(v) {
    if (!v) return '';
    if (PT_IDX > -1 && v.options[PT_IDX]) return v.options[PT_IDX];
    var b = bundleSku(v.sku);
    return b && b.type ? (b.type === 'P' ? 'Polaroid' : 'Strip') : '';
  }
  /** Logo code of a variant: SKU (…-ML/-NL/-EL) first, else the logo option's words; '' = the product has no logo choice */
  function logoCodeOf(v) {
    if (!v) return '';
    var b = bundleSku(v.sku);
    if (b && b.logo) return b.logo;
    return LOGO_IDX > -1 ? logoCodeOfText(v.options[LOGO_IDX]) : '';
  }
  function firstOptionIsDuration() {
    return DUR_IDX > -1;
  }
  function durOfVariant(v) {
    return v ? String(v.options[DUR_IDX > -1 ? DUR_IDX : 0] || '') : '';
  }
  // an incoming ?variant= (Google Shopping, shared links): read once, then removed from the address bar
  var LANDING_ID = '';
  if (SEASONAL) {
    var lm = /[?&]variant=(\d+)/.exec(location.search);
    if (lm) {
      LANDING_ID = lm[1];
      try {
        var qs = location.search.replace(/([?&])variant=\d+&?/, '$1').replace(/[?&]$/, '');
        history.replaceState(history.state, '', location.pathname + qs + location.hash);
      } catch (e) { /* ignore */ }
    }
  }
  var LEASE_WORD = /m[åa]ned|månad|monat|month/i;
  /** Lease months (M-93 … M-730), from the booth SKU; without one from the duration's words */
  function isLease(v) {
    if (!IS_BOOTH || !v) return false;
    var c = boothCode(v.sku);
    return c ? isLeaseCode(c) : LEASE_WORD.test(durOfVariant(v));
  }
  /** Duration code ('W', '1', '2', '7', '93' …) of a duration name: this product's variants, the booking module's
      booth products, else the name's words. */
  function durCode(name) {
    if (!name) return '';
    var i;
    for (i = 0; i < variants.length; i++) {
      if (durOfVariant(variants[i]) === name && boothCode(variants[i].sku)) return boothCode(variants[i].sku);
    }
    var ps = document.querySelector('myselfie-product-selector');
    var booths = ps && ps.cfg && ps.cfg.booth;
    if (booths) {
      for (var h in booths) {
        var p = booths[h];
        var vs = (p && p.variants) || [];
        for (i = 0; i < vs.length; i++) {
          var c = boothCode(vs[i].sku);
          if (c && (vs[i].options || []).indexOf(name) > -1) return c;
        }
      }
    }
    if (/^(weekend|helg|wochenende)$/i.test(name)) return 'W';
    if (/^1 (hverdag|vardag|werktag|weekday)$/i.test(name)) return '1';
    if (LEASE_WORD.test(name)) return '93';
    return '';
  }
  function isLeaseName(name) { return isLeaseCode(durCode(name)); }
  /** The weekend rental's name in this store ("Weekend", "Helg" …): the module's / this product's durations */
  function weekendName() {
    var names = [];
    var ps = document.querySelector('myselfie-product-selector');
    try { if (ps && ps.cfg && typeof ps.durations === 'function') names = ps.durations() || []; } catch (e) { names = []; }
    variants.forEach(function (v) { var d = durOfVariant(v); if (DUR_IDX > -1 && names.indexOf(d) < 0) names.push(d); });
    for (var i = 0; i < names.length; i++) if (durCode(names[i]) === 'W') return names[i];
    return tx('pdp', 'weekend', 'Weekend');
  }

  /* ---------------------------------------------------------------- price (date-dependent on booth pages) */
  var PER_BUNDLE = root.getAttribute('data-per-bundle') || '';
  var serverIso = root.getAttribute('data-cart-iso') || ''; // the cart's booking date when the page was rendered
  var boothPricer = null; // the booking module's price for a variant ({amount, mode, iso, duration}), once it is ready
  var datedModule = null; // () -> the booking module's date (season products), once it is ready
  /** øre -> the shop's money format, shaped like a sample of it (ViaBill reads data-price) */
  function moneyLike(ore, sample) {
    var m = /^([^\d]*)[\d.,\s]*\d([^\d]*)$/.exec(String(sample || ''));
    var num = fmtNum(Math.round(ore) / 100, 2);
    return m ? m[1] + num + m[2] : tx('common', 'money', '[amount] kr', { amount: num });
  }
  /** {amount, mode: 'from' | 'exact' | 'plain', iso} for a variant */
  function priceState(v) {
    if (!IS_BOOTH || !v || isLease(v)) return { amount: v ? v.price : 0, mode: 'plain' };
    // Google Shopping landing (?variant= of a season product): that variant's own price until a date is known
    if (SEASONAL && LANDING_ID && String(v.id) === LANDING_ID && !serverIso && !(datedModule && datedModule())) return { amount: v.price, mode: 'plain' };
    if (boothPricer) {
      var r = boothPricer(v);
      if (r) return r;
    }
    if (typeof v.min !== 'number') return { amount: v.price, mode: 'plain' };
    if (serverIso && v.exact >= 0) return { amount: v.exact, mode: 'exact', iso: serverIso };
    return { amount: v.min, mode: v.max > v.min ? 'from' : 'plain' };
  }
  function perText(v, st) {
    if (!IS_BOOTH || !v) return '';
    if (firstOptionIsDuration()) return tx('pdp', 'for_duration', 'for [duration]', { duration: durOfVariant(v).toLowerCase() });
    var d = st && st.duration;
    var code = d ? durCode(d) : '';
    return !d || code === 'W' || code === '1' ? PER_BUNDLE : tx('pdp', 'for_duration', 'for [duration]', { duration: d.toLowerCase() });
  }
  /** Hero, sticky bar, Fakta and ViaBill: "fra 999 kr. for weekend" / "1.299 kr for weekend" / the variant price. */
  function renderPrice(v) {
    v = v || current;
    if (!v) return;
    var st = priceState(v);
    var from = st.mode === 'from';
    var text = from ? tx('pdp', 'from_amount', '[amount].', { amount: fmt(st.amount) }) : fmt(st.amount);
    var per = perText(v, st);
    all('[data-pdp-amount]').forEach(function (el) { el.textContent = text; });
    all('[data-pdp-from]', root).forEach(function (el) { el.hidden = !from; });
    if (IS_BOOTH) all('[data-pdp-per]').forEach(function (el) { el.textContent = per; });
    all('[data-pdp-compare]', root).forEach(function (el) {
      var on = st.amount === v.price && v.compare > v.price;
      el.textContent = on ? v.compareText : '';
      el.hidden = !on;
    });
    all('[data-pdp-note]', root).forEach(function (n) { n.hidden = !from; });
    all('[data-pdp-dateprice]', root).forEach(function (n) {
      var on = st.mode === 'exact' && !!st.iso;
      n.textContent = on ? tx('pdp', 'price_applies', 'Prisen gælder d. [date].', { date: isoToShort(st.iso) }) : '';
      n.hidden = !on;
    });
    all('[data-pdp-viabill]', root).forEach(function (el) { el.setAttribute('data-price', st.amount === v.price ? v.money : moneyLike(st.amount, v.money)); });
    all('[data-pdp-fact-price]').forEach(function (el) {
      var p = IS_BOOTH ? (per ? ' ' + per : '') : (el.getAttribute('data-per') || '');
      el.textContent = tx('pdp', 'fact_price', '[price][per] – inkl. moms', { price: (from ? tx('pdp', 'from_word', 'fra') + ' ' : '') + text, per: p });
    });
    // duration chips: the same rule per chip ("fra 999 kr" / the price on the date)
    if (IS_BOOTH) {
      all('[data-pdp-chip-price]', root).forEach(function (el) {
        var chip = el.closest('[data-pdp-chip]');
        var id = chip && chip.getAttribute('data-variant');
        var cv = null;
        for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === id) cv = variants[i];
        if (!cv) return;
        var cs = priceState(cv);
        el.textContent = cs.mode === 'from' ? tx('pdp', 'from_price', 'fra [price]', { price: fmt(cs.amount) }) : fmt(cs.amount);
      });
    }
  }

  /* ---------------------------------------------------------------- variants */
  function resolve(oi, value, base) {
    var want = base.options.slice();
    want[oi] = value;
    var exact = null;
    var loose = null;
    variants.forEach(function (v) {
      if (!loose && v.options[oi] === value) loose = v;
      if (!exact && v.options.every(function (o, j) { return o === want[j]; })) exact = v;
    });
    return exact || loose;
  }

  var stateListeners = [];
  function onVariant(fn) { stateListeners.push(fn); }

  function renderVariant(v, opts) {
    opts = opts || {};
    current = v;
    if (idInput) idInput.value = v.id;
    renderPrice(v);
    // chips: state, availability and their links (the other options stay as chosen)
    all('[data-pdp-chip]', root).forEach(function (chip) {
      var oi = +chip.getAttribute('data-opt');
      var val = chip.getAttribute('data-value');
      var target = resolve(oi, val, v) || v;
      var on = v.options[oi] === val;
      chip.classList.toggle('is-on', on);
      chip.setAttribute('aria-checked', on ? 'true' : 'false');
      chip.classList.toggle('is-out', !target.available);
      if (target.available) chip.removeAttribute('aria-disabled'); else chip.setAttribute('aria-disabled', 'true');
      chip.setAttribute('data-variant', target.id);
      if (!SEASONAL) chip.setAttribute('href', location.pathname + '?variant=' + target.id);
      var out = chip.querySelector('.mys-pdp__chip-out');
      if (!target.available && !out) {
        out = document.createElement('span');
        out.className = 'mys-pdp__chip-out';
        out.textContent = tx('pdp', 'sold_out', 'Udsolgt');
        chip.appendChild(out);
      } else if (target.available && out) out.parentNode.removeChild(out);
    });
    all('[data-pdp-opt]', root).forEach(function (fs) {
      var oi = +fs.getAttribute('data-pdp-opt');
      var span = fs.querySelector('[data-pdp-opt-value]');
      if (span) span.textContent = ': ' + v.options[oi];
    });
    if (SEASONAL && LANDING_ID && String(v.id) !== LANDING_ID && opts.user) LANDING_ID = ''; // the customer chose: no landing price any more
    // booth CTA: lease months go to the lease page, everything else to the booking module
    var lease = isLease(v);
    if (IS_BOOTH) {
      all('[data-pdp-lease]', root).forEach(function (d) { if (lease) d.open = true; });
      var inCart = root.getAttribute('data-booth-in-cart') === 'true';
      var label = lease ? root.getAttribute('data-cta-lease')
        : IS_BUNDLE ? (inCart ? root.getAttribute('data-cta-bundle-in-cart') : root.getAttribute('data-cta-bundle'))
          : (inCart ? root.getAttribute('data-cta-booth-in-cart') : root.getAttribute('data-cta-booth'));
      var href = lease ? root.getAttribute('data-lease-url') : IS_BUNDLE ? '#pdp-bundle' : '#' + (root.getAttribute('data-anchor') || 'book-myselfie');
      all('[data-pdp-booth-cta]').forEach(function (a) {
        a.setAttribute('href', href);
        var l = a.querySelector('[data-pdp-cta-label]');
        if (!l) return;
        if (!l.hasAttribute('data-label')) l.setAttribute('data-label', l.textContent);
        // the sticky bar keeps its short label ("Vælg dato") for the booking module
        l.textContent = a.hasAttribute('data-pdp-sticky-cta') && !lease ? (l.getAttribute('data-sticky') || l.getAttribute('data-label')) : label;
      });
      all('[data-pdp-cta-icon]', root).forEach(function (i) { i.textContent = lease || IS_BUNDLE ? '→' : '↓'; });
    } else {
      all('[data-pdp-cta], [data-pdp-sticky-cta]').forEach(function (b) {
        if (b.tagName !== 'BUTTON') return;
        b.disabled = !v.available || b.hasAttribute('data-sold-out-date');
        var l = b.querySelector('[data-pdp-cta-label]');
        if (l) {
          if (!l.getAttribute('data-label')) l.setAttribute('data-label', l.textContent);
          var soldOut = tx('pdp', 'sold_out', 'Udsolgt');
          if (!v.available) l.textContent = soldOut;
          else if (l.textContent === soldOut && !b.hasAttribute('data-sold-out-date')) l.textContent = l.getAttribute('data-label') === soldOut ? tx('pdp', 'add_to_cart', 'Læg i kurv') : l.getAttribute('data-label');
        }
      });
    }
    if (v.media && gallery) gallery.goToMedia(v.media);
    if (opts.push && !SEASONAL && window.history && history.replaceState) {
      try { history.replaceState(history.state, '', location.pathname + '?variant=' + v.id + location.hash); } catch (e) { /* ignore */ }
    }
    try { document.dispatchEvent(new CustomEvent('mys-pdp:variant', { detail: { variant: v, user: !!opts.user } })); } catch (e) { /* old browsers */ }
    stateListeners.forEach(function (fn) { try { fn(v, opts); } catch (e) { /* ignore */ } });
  }

  root.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-pdp-chip]');
    if (!chip || !root.contains(chip) || !current) return;
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    var target = resolve(+chip.getAttribute('data-opt'), chip.getAttribute('data-value'), current);
    if (!target || target.id === current.id) return;
    renderVariant(target, { push: true, user: true });
  });

  document.addEventListener('myselfie:date', function (e) {
    var d = (e && e.detail) || {};
    if (!IS_BOOTH || !d.cleared) return;
    serverIso = '';
    renderPrice();
  });

  /* ---------------------------------------------------------------- gallery */
  var gallery = (function () {
    var box = root.querySelector('[data-pdp-gallery]');
    var track = box && box.querySelector('[data-pdp-track]');
    if (!track) return null;
    var slides = all('[data-pdp-slide]', track);
    var thumbs = all('[data-pdp-thumb]', box);
    var active = 0;
    function mark(i) {
      active = i;
      thumbs.forEach(function (t, j) {
        t.classList.toggle('is-on', j === i);
        if (j === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
      });
    }
    function go(i, smooth) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
      mark(i);
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { go(+t.getAttribute('data-pdp-thumb'), true); });
    });
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== active) mark(i);
      });
    }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1, true); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(active - 1, true); }
    });
    // pause videos that scroll out of view
    return {
      goToMedia: function (id) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === String(id)) { go(i, true); return; }
        }
      },
    };
  })();

  /* ---------------------------------------------------------------- goto (in-page CTAs) */
  function gotoHash(hash) {
    var id = String(hash || '').replace(/^#/, '');
    if (!id) return false;
    if (id === (root.getAttribute('data-anchor') || 'book-myselfie') && window.myselfie && typeof window.myselfie.goToBooking === 'function') {
      return window.myselfie.goToBooking();
    }
    var el = document.getElementById(id);
    if (!el) return false;
    scrollToEl(el);
    if (id === 'pdp-buy') {
      var focusEl = root.querySelector('.mys-pdp__date-input:not([disabled])') || root.querySelector('[data-pdp-cta]');
      setTimeout(function () { focusQuietly(focusEl); }, reduceMotion ? 0 : 450);
    } else {
      focusQuietly(el);
    }
    return true;
  }
  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest && e.target.closest('[data-pdp-goto], [data-pdp-booth-cta]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (href.charAt(0) !== '#') return; // lease page link
    if (gotoHash(href)) e.preventDefault();
  });

  /* ---------------------------------------------------------------- add to cart (dated / add-on / related) */
  function parse(r) {
    var ct = (r.headers && r.headers.get('content-type')) || '';
    if (r.status === 429) return Promise.reject({ soft: true, message: tx('pdp', 'err_busy', 'Der er travlt i webshoppen lige nu. Vent et øjeblik, og prøv igen.') });
    if (ct.indexOf('text/html') > -1) return Promise.reject({ fallback: true });
    return r.json().then(function (body) {
      if (!r.ok) throw { soft: true, message: (body && (body.description || body.message)) || tx('pdp', 'err_add', 'Varen kunne ikke lægges i kurven.') };
      return body;
    });
  }
  function afterAdd() {
    try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) { /* ignore */ }
    try { if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart(); } catch (e) { /* ignore */ }
    return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || typeof cart.item_count !== 'number') return;
        document.dispatchEvent(new CustomEvent('myselfie:cart', { detail: cartDetail(cart) }));
      })
      .catch(noop);
  }
  function addForm(f, ui) {
    ui.busy(true);
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(f) })
      .then(parse)
      .then(function (item) {
        ui.done(item);
        return afterAdd();
      })
      .catch(function (err) {
        if (err && err.soft) ui.error(err.message);
        else f.submit(); // network error or an HTML answer: the browser's plain POST still works
      })
      .then(function () { ui.busy(false); });
  }

  /* ---------------------------------------------------------------- dated (Mygreetings, MyGallery) */
  var dated = (function () {
    var box = root.querySelector('[data-pdp-dated]');
    if (!box) return null;
    var picker = box.querySelector('myselfie-datepicker');
    var input = box.querySelector('.mys-pdp__date-input');
    var prop = box.querySelector('[data-pdp-date-prop]');
    var status = box.querySelector('[data-pdp-date-status]');
    var comp = box.getAttribute('data-components') || 'Mygreetings';
    var locked = !!box.getAttribute('data-cart-date');
    var TEXT = {
      available: tx('pdp', 'status_available', 'Ledig'), popular: tx('pdp', 'status_popular', 'Populær dato'),
      low: tx('pdp', 'status_low', 'Få tilbage'), sold_out: tx('pdp', 'sold_out', 'Udsolgt'),
    };

    function avail() { return window.myselfie && window.myselfie.availability; }
    function knownProduct() {
      var a = avail();
      return !!(a && a.data && a.data.products && a.data.products[comp.toLowerCase()]);
    }
    /** status for this product only: a product the API does not list (GallerySA) is always bookable (as api-dates.js) */
    function statusFor(iso) {
      var a = avail();
      if (!a || !a.data || !knownProduct()) return 'available';
      return a.statusFor(iso, [comp]);
    }
    /** lead-block day for this product (backend field "lead"): not offered, like a past date */
    function leadOf(iso) {
      var a = avail();
      return !!(a && a.data && knownProduct() && typeof a.isLead === 'function' && a.isLead(iso, [comp]));
    }
    function setStatus(text, state) {
      status.textContent = text;
      if (state) status.setAttribute('data-state', state); else status.removeAttribute('data-state');
    }
    function ctas() { return all('[data-pdp-cta], [data-pdp-sticky-cta]').filter(function (b) { return b.tagName === 'BUTTON'; }); }
    function setSoldOut(on) {
      ctas().forEach(function (b) {
        var l = b.querySelector('[data-pdp-cta-label]');
        if (l && !l.getAttribute('data-label')) l.setAttribute('data-label', l.textContent);
        if (on) {
          b.setAttribute('data-sold-out-date', '');
          b.disabled = true;
          if (l) l.textContent = tx('pdp', 'sold_out', 'Udsolgt');
        } else {
          b.removeAttribute('data-sold-out-date');
          b.disabled = !(current && current.available);
          if (l && current && current.available) l.textContent = l.getAttribute('data-label') || tx('pdp', 'add_to_cart', 'Læg i kurv');
        }
      });
    }
    function apply(display) {
      var iso = displayToIso(display);
      if (!iso) {
        prop.value = '';
        setStatus('', '');
        setSoldOut(false);
        return;
      }
      prop.value = display;
      if (locked) {
        setStatus(tx('pdp', 'same_date_as_booking', 'Samme dato som din booking: [date]', { date: display }), 'available');
        setSoldOut(statusFor(iso) === 'sold_out');
        return;
      }
      if (leadOf(iso)) { // a remembered date inside the lead block is not accepted
        input.value = '';
        prop.value = '';
        setStatus('', '');
        setSoldOut(false);
        return;
      }
      var st = statusFor(iso);
      setStatus((TEXT[st] || TEXT.available) + ' ' + tx('date', 'on', 'd. [date]', { date: display }), st);
      setSoldOut(st === 'sold_out');
    }
    function lock(display) {
      locked = true;
      box.classList.add('is-locked');
      input.value = display;
      input.disabled = true;
      apply(display);
    }

    input.addEventListener('change', function () { if (!locked) apply(input.value); });
    document.addEventListener('myselfie:date', function (e) {
      var d = (e && e.detail) || {};
      if (d.cleared && !locked) {
        input.value = '';
        apply('');
        return;
      }
      if (locked || d.source === 'pdp' || !d.display) return;
      input.value = d.display;
      apply(d.display);
    });
    // availability: products the API does not know are never blocked (the component would fall back to the aggregate)
    var a = avail();
    if (a && typeof a.load === 'function') {
      a.load().then(function () {
        if (!knownProduct() && picker) {
          picker.booked = {};
          picker.low = {};
          picker.popular = {};
          picker.lead = {};
          if (picker.calendar && typeof picker.render === 'function') picker.render();
        }
        setTimeout(function () { if (input.value) apply(input.value); }, 0);
      });
    } else if (input.value) apply(input.value);
    // one booking date per order: a cart line with a Date locks the field to it (the cart page would empty a cart with two dates)
    if (!locked) {
      fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          for (var i = 0; i < cart.items.length; i++) {
            var p = cart.items[i].properties || {};
            if (p.Date && displayToIso(p.Date)) { lock(p.Date); return; }
          }
        })
        .catch(noop);
    } else apply(input.value);

    return {
      ready: function () { return !!prop.value; },
      hint: function () {
        setStatus(tx('pdp', 'pick_date_first', 'Vælg datoen for jeres fest først.'), 'hint');
        scrollToEl(box);
        setTimeout(function () { try { input.focus(); } catch (e) { /* ignore */ } }, reduceMotion ? 0 : 400);
      },
    };
  })();

  /* ---------------------------------------------------------------- add-on / dated submit */
  if (form && !IS_BOOTH) {
    var cta = form.querySelector('button[data-pdp-cta]');
    var label = cta && cta.querySelector('[data-pdp-cta-label]');
    var statusEl = form.querySelector('[data-pdp-status]');
    var errEl = form.querySelector('[data-pdp-err]');
    var resetTimer = 0;
    var title = (root.querySelector('#pdp-title') || {}).textContent || tx('pdp', 'the_item', 'Varen');
    form.addEventListener('submit', function (e) {
      if (dated && !dated.ready()) {
        e.preventDefault();
        dated.hint();
        return;
      }
      if (!window.fetch || !window.FormData) return; // native POST
      e.preventDefault();
      if (!cta || cta.disabled || cta.getAttribute('aria-busy') === 'true') return;
      if (errEl) { errEl.hidden = true; errEl.textContent = ''; }
      var original = label ? (label.getAttribute('data-label') || label.textContent) : '';
      if (label && !label.getAttribute('data-label')) label.setAttribute('data-label', original);
      addForm(form, {
        busy: function (on) {
          if (on) { cta.setAttribute('aria-busy', 'true'); if (label) label.textContent = tx('pdp', 'adding', 'Lægger i kurv…'); }
          else cta.removeAttribute('aria-busy');
        },
        done: function () {
          cta.classList.add('is-added');
          if (label) label.textContent = tx('pdp', 'added', '✓ Lagt i kurven');
          if (statusEl) statusEl.innerHTML = tx('pdp', 'added_status_html', '»[title]« er lagt i kurven. <a href="[url]">Gå til kurv</a>', { title: title.trim().replace(/[<>&]/g, ''), url: ROOT + 'cart' });
          clearTimeout(resetTimer);
          resetTimer = setTimeout(function () {
            cta.classList.remove('is-added');
            if (label && !cta.disabled) label.textContent = original;
          }, 4000);
        },
        error: function (msg) {
          if (label) label.textContent = original;
          if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
        },
      });
    });
    // quantity stepper
    all('[data-pdp-qty]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = form.querySelector('[data-pdp-qty-input]');
        if (!inp) return;
        var n = Math.max(1, Math.min(20, (parseInt(inp.value, 10) || 1) + (+b.getAttribute('data-pdp-qty'))));
        inp.value = n;
      });
    });
  }

  /* ---------------------------------------------------------------- sticky bar (mobile) */
  (function () {
    var bar = root.querySelector('[data-pdp-sticky]');
    var heroCta = root.querySelector('.mys-pdp__form [data-pdp-cta]');
    if (!bar || !heroCta) return;
    var mq = window.matchMedia('(max-width: 989px)');
    var moduleEl = document.querySelector('myselfie-product-selector');
    var footer = document.querySelector('#shopify-section-sections--footer, footer, .site-footer, [class*="footer-group"]');
    var boothInCart = IS_BOOTH && root.getAttribute('data-booth-in-cart') === 'true';
    bar.hidden = false;
    var stickyBtn = bar.querySelector('button[data-pdp-sticky-cta]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (dated && !dated.ready()) return dated.hint();
        if (form.requestSubmit) form.requestSubmit(heroCta); else heroCta.click();
      });
    }
    function inView(el) {
      if (!el) return false;
      var r = el.getBoundingClientRect();
      return r.height > 0 && r.top < window.innerHeight && r.bottom > 0;
    }
    function update() {
      var r = heroCta.getBoundingClientRect();
      var past = r.bottom < 0;
      var show = mq.matches && past && !boothInCart && !inView(moduleEl) && !inView(footer) && !document.querySelector('dialog[open]') && !document.documentElement.classList.contains('mys-nav-open');
      bar.classList.toggle('is-on', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      all('a, button', bar).forEach(function (el) { if (show) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
      document.body.classList.toggle('mys-pdp-sticky-on', show);
    }
    var raf = 0;
    function schedule() { if (!raf) raf = requestAnimationFrame(function () { raf = 0; update(); }); }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    document.addEventListener('myselfie:cart', function (e) {
      var d = e && e.detail;
      var n = d ? (typeof d.paid_count === 'number' ? d.paid_count : d.item_count) : 0;
      if (IS_BOOTH && typeof n === 'number' && n > 0) { boothInCart = true; schedule(); }
    });
    update();
  })();

  /* ---------------------------------------------------------------- booth pages: hand-off to the booking module */
  (function () {
    if (!IS_BOOTH || !window.customElements || IS_WHOLE) return;
    var ps = document.querySelector('myselfie-product-selector');
    if (!ps) return;
    var explicit = /[?&]variant=\d+/.test(location.search) || !!LANDING_ID; // season products: already removed from the URL
    var hasPrinter = KIND === 'booth-print' || KIND === 'booth-premium';
    var hasMyg = KIND === 'booth-mygreetings' || KIND === 'booth-premium';
    var touched = {}; // module controls the customer clicked on this page
    var presetDone = false;
    var presetRunning = false;
    var printerOurs = false; // the printer was switched on by the preset (so its options follow the hero)

    function warn(msg) { if (window.console && console.warn) console.warn('[mys-pdp] ' + msg); }
    function frame() { return new Promise(function (r) { requestAnimationFrame(function () { setTimeout(r, 60); }); }); }
    function q(sel) { return ps.querySelector(sel); }
    function esc(s) { return window.CSS && CSS.escape ? CSS.escape(s) : String(s).replace(/"/g, '\\"'); }
    function ready() { return !!(ps.cfg && ps.state && ps.el && ps.querySelector('[data-ps-action="duration"]')); }
    function whenReady() {
      return customElements.whenDefined('myselfie-product-selector').then(function () {
        return new Promise(function (resolveReady, reject) {
          var t0 = Date.now();
          (function poll() {
            if (ready()) return resolveReady();
            if (Date.now() - t0 > 20000) return reject(new Error('module not ready'));
            setTimeout(poll, 120);
          })();
        });
      });
    }
    function heroDuration() {
      if (!current) return weekendName();
      return firstOptionIsDuration() ? durOfVariant(current) : weekendName();
    }
    function pushDuration() {
      if (!current || isLease(current)) return;
      var d = heroDuration();
      if (!d || ps.state.duration === d) return;
      var btn = q('[data-ps-action="duration"][data-value="' + esc(d) + '"]');
      if (btn && !btn.disabled) btn.click();
    }
    /** module -> hero: same duration on this product (only products whose first option is the duration) */
    function pullDuration(user) {
      if (!firstOptionIsDuration() || !current) return;
      var d = ps.state.duration;
      if (!d || durOfVariant(current) === d) return;
      var v = resolve(DUR_IDX, d, current);
      if (v && durOfVariant(v) === d) renderVariant(v, { push: !!user, user: false, fromModule: true });
    }
    /** Season products: the hero's variant is always the one of the module's date (default season without one). */
    function syncSeason() {
      var k = SK();
      if (!SEASONAL || !k || !current) return;
      var want = k.seasonFor(ps.state.iso || '');
      if (!want || k.same(current.options[SEASON_IDX], want)) return;
      var others = {};
      current.options.forEach(function (o, i) { if (i !== SEASON_IDX) others[i] = o; });
      var v = k.pick({ options: OPTION_NAMES, variants: variants }, { others: others, season: want });
      if (v && v.id !== current.id && !(LANDING_ID && String(current.id) === LANDING_ID && !ps.state.iso)) renderVariant(v, { push: false, user: false, fromModule: true });
    }
    /** The module's logo value for a logo code: '' (Myselfie Logo), 'NL' (Ingen logo), 'EL' (Eget logo). */
    function logoId(code) {
      return code === 'EL' || code === 'NL' ? code : '';
    }
    function moduleLogo() { return typeof ps.logoCode === 'function' ? ps.logoCode() : String(ps.state.logo || ''); }
    /** The module's print type value for a name ("Fotostribe" -> "Strip" when the printer product says Strip). */
    function moduleType(t) { return typeof ps.printTypeValue === 'function' ? ps.printTypeValue(t) : t; }
    /** "Logo på print" variant (logo code + print type, season of the day); null without the module helper. */
    function logoFor(code, type, day) { return typeof ps.logoVariantFor === 'function' ? ps.logoVariantFor(code || 'ML', type, day) : null; }
    function wantedPrints(v) {
      v = v || current;
      var b = v && bundleSku(v.sku);
      if (b) return b.prints;
      var n = v && PRINTS_IDX > -1 ? parseInt(v.options[PRINTS_IDX], 10) : 0;
      return n > 0 ? n : 400;
    }
    function mygKey() {
      var list = (ps.cfg && ps.cfg.addons) || [];
      for (var i = 0; i < list.length; i++) if (list[i].product && list[i].product.handle === 'mygreetings') return list[i].key;
      // other stores: the Mygreetings add-on by its SKU (MYG)
      for (i = 0; i < list.length; i++) {
        var pv = list[i].product && list[i].product.variants && list[i].product.variants[0];
        if (pv && /^MYG$/i.test(String(pv.sku || '').trim())) return list[i].key;
      }
      return '';
    }
    function click(sel) {
      var el = q(sel);
      if (!el || el.disabled) return false;
      el.click();
      return true;
    }
    async function syncPrinterOptions() {
      if (!ps.state.printer) return;
      var pt = printTypeOf(current);
      if (pt) pt = moduleType(pt);
      if (pt && ps.state.printType !== pt) { click('[data-ps-action="print-type"][data-value="' + esc(pt) + '"]'); await frame(); }
      var lc = logoCodeOf(current);
      if (lc) {
        var id = logoId(lc);
        if (moduleLogo() !== id) { click('[data-ps-action="logo"][data-value="' + esc(id) + '"]'); await frame(); }
      }
      var target = wantedPrints();
      for (var i = 0; i < 8 && ps.state.prints !== target; i++) {
        var up = ps.state.prints < target;
        if (!click('[data-ps-action="prints"][data-value="' + (up ? '' : '-') + '400"]')) break;
        await frame();
      }
    }
    async function applyPreset() {
      if (presetDone || presetRunning) return;
      if (!ps.state.iso || (typeof ps.needsDate === 'function' && ps.needsDate(true))) return;
      presetRunning = true;
      try {
        await frame();
        pushDuration();
        await frame();
        if (hasPrinter && !touched.printer) {
          if (!ps.state.printer) {
            if (click('.myselfie-ps__pill[data-ps-action="printer"]')) { printerOurs = true; await frame(); }
            else warn('preset skipped: printer');
          }
          if (printerOurs) await syncPrinterOptions();
        }
        if (hasMyg && !touched.addon) {
          var key = mygKey();
          if (key && !ps.state.addons[key]) {
            if (!click('.myselfie-ps__pill[data-ps-action="addon"][data-value="' + esc(key) + '"]')) warn('preset skipped: mygreetings');
            await frame();
          }
        }
        presetDone = true;
      } catch (err) {
        warn('preset skipped');
      }
      presetRunning = false;
      renderDatePrice();
    }

    /** Duration the hero's price is for: the product's own (rental period option), else the module's once dated, else Weekend. */
    function durationFor(v) {
      if (firstOptionIsDuration()) return durOfVariant(v);
      return (ps.state && ps.state.iso && ps.state.duration) || weekendName();
    }
    /** What the module adds to the booth for this bundle variant on a day: printer, logo, extra rolls, Mygreetings. */
    function partsFor(v, d, day) {
      var total = 0;
      if (day === undefined) day = ps.state.iso;
      if (hasPrinter) {
        var pv = ps.printerVariant(d, day);
        if (pv) total += pv.price;
        var lvar = logoFor(logoId(logoCodeOf(v)) || 'ML', printTypeOf(v), day);
        if (lvar) total += lvar.price;
        var roll = ps.rollVariant && ps.rollVariant(day);
        var extra = Math.max(0, Math.round(wantedPrints(v) / 400) - 1);
        if (roll && extra) total += roll.price * extra;
      }
      if (hasMyg) {
        var key = mygKey();
        (ps.cfg.addons || []).forEach(function (a) {
          var av = a.key === key && (ps.addonVariant ? ps.addonVariant(a, day) : a.product.variants[0]);
          if (av) total += av.price;
        });
      }
      return total;
    }
    /** The module's price for a variant: exact on its date, else "fra" (lowest sellable booth price + parts). */
    function modulePrice(v) {
      if (!ready() || !v || isLease(v)) return null;
      try {
        var d = durationFor(v);
        var iso = ps.state.iso;
        if (iso) {
          var booth = ps.boothVariant(iso, d);
          return booth ? { amount: booth.price + partsFor(v, d), mode: 'exact', iso: iso, duration: d } : null;
        }
        if (typeof ps.spanOf === 'function') {
          // the cheapest day for the booth and its parts together (date ranges and seasons alike)
          var all = ps.spanOf(function (day) {
            var b = ps.boothVariant(day, d);
            return b ? b.price + partsFor(v, d, day) : null;
          });
          if (all.min === null) return null;
          return { amount: all.min, mode: all.varies ? 'from' : 'plain', duration: d };
        }
        if (typeof ps.boothPriceSpan !== 'function') return null;
        var span = ps.boothPriceSpan(d);
        if (!span.min) return null;
        return { amount: span.min.price + partsFor(v, d), mode: span.varies ? 'from' : 'plain', duration: d };
      } catch (err) {
        return null;
      }
    }
    function renderDatePrice() { syncSeason(); renderPrice(); }


    /* ------------------------------------------------------------ bundles: "Læg i kurv" -> confirm -> parts -> /cart
       Owner 2026-10-05 (_qa/bundles/plan.md): a bundle page never adds the bundle variant. The dialog asks for the
       date (the remembered one when there is one), print type, logo and prints; the booking module on the page then
       puts the separate products in the cart (booth + printer with print_mode + logo + extra prints + Mygreetings, in
       the date's season), and the customer goes to /cart. The module's own "Gå til betaling" also ends on /cart here. */
    var bundleUi = (function () {
      if (!IS_BUNDLE) return null;
      var dlg = root.querySelector('[data-pdp-bundle]');
      if (!dlg || typeof dlg.showModal !== 'function') return null;
      var $b = function (sel) { return dlg.querySelector(sel); };
      var el = {
        known: $b('[data-pdp-bundle-known]'), pick: $b('[data-pdp-bundle-pick]'), dateText: $b('[data-pdp-bundle-date-text]'),
        lock: $b('[data-pdp-bundle-lock]'), change: $b('[data-pdp-bundle-change]'), input: $b('[data-pdp-bundle-date]'),
        status: $b('[data-pdp-bundle-status]'), options: $b('[data-pdp-bundle-options]'), summary: $b('[data-pdp-bundle-summary]'),
        err: $b('[data-pdp-bundle-err]'), confirm: $b('[data-pdp-bundle-confirm]'), close: $b('[data-pdp-bundle-close]'),
      };
      var choice = null;
      var busy = false;
      var opener = null;
      var confirmLabel = el.confirm ? el.confirm.textContent : '';

      function isoToDisplay(iso) { var p = iso.split('-'); return p[2] + '/' + p[1] + '/' + p[0]; }
      function tomorrowIso() { var t = new Date(); t = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1); return t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate()); }
      function longDate(iso) {
        var p = iso.split('-');
        var d = new Date(+p[0], +p[1] - 1, +p[2]);
        var wd = tx('date', 'weekdays', 'søndag,mandag,tirsdag,onsdag,torsdag,fredag,lørdag').split(',');
        var mo = tx('date', 'months', 'januar,februar,marts,april,maj,juni,juli,august,september,oktober,november,december').split(',');
        var date = tx('date', 'day_month_year', '[day]. [month] [year]', { day: d.getDate(), month: mo[d.getMonth()], year: d.getFullYear() });
        return tx('date', 'weekday_on', '[weekday] d. [date]', { weekday: wd[d.getDay()], date: date });
      }
      function storedIso() {
        var v = '';
        try { v = sessionStorage.getItem('wdn_bookingdate') || ''; } catch (e) { v = ''; }
        var iso = displayToIso(v);
        return iso && iso >= tomorrowIso() ? iso : '';
      }
      /** The date of a booth already in the cart (the module adopted it): one date per order, so it is locked. */
      function lockedIso() {
        var cs = ps.cartSync;
        if (!cs || !cs.cart || typeof ps.cartHasBooth !== 'function' || !ps.cartHasBooth(cs.cart)) return '';
        return ps.state.iso && ps.state.iso >= tomorrowIso() ? ps.state.iso : '';
      }
      function printTypes() {
        var t = typeof ps.printTypes === 'function' ? ps.printTypes() : null;
        return t && t.values && t.values.length ? t.values : tx('pdp', 'print_types', 'Polaroid,Fotostribe').split(',');
      }
      function durations() { return typeof ps.durations === 'function' ? ps.durations() : [weekendName()]; }
      /** Weekend rentals are Friday-Sunday: a Monday-Thursday date is a weekday rental (as the module). */
      function effDuration() {
        var d = choice.duration || weekendName();
        if (choice.iso && typeof ps.weekendBlocked === 'function' && ps.weekendBlocked(choice.iso) && durCode(d) === 'W') {
          var list = durations();
          for (var i = 0; i < list.length; i++) if (durCode(list[i]) === '1') return list[i];
        }
        return d;
      }
      function maxPrints() {
        var rolls = Number(ps.getAttribute('data-max-rolls')) || 5;
        return ps.rollVariant && ps.rollVariant(choice.iso || '') ? 400 + 400 * rolls : 400;
      }
      /** Logo variant for a code (NL/EL) in the date's season; null for the free Myselfie logo. */
      function logoVariant(code, iso) { return logoFor(code, choice.printType, iso || ''); }
      function logoLabel(code) {
        var K = window.myselfie && window.myselfie.checkoutKit;
        return K && K.logoName && ps.cfg && ps.cfg.logo ? K.logoName(ps.cfg.logo, code) : ({ ML: tx('pdp', 'logo_ml', 'Myselfie Logo'), NL: tx('pdp', 'logo_nl', 'Ingen logo'), EL: tx('pdp', 'logo_el', 'Eget logo') })[code];
      }
      function mygAddon() {
        var key = mygKey();
        var list = (ps.cfg && ps.cfg.addons) || [];
        for (var i = 0; i < list.length; i++) if (list[i].key === key) return list[i];
        return null;
      }
      /** The lines for a day ('' = no date: null): [{label, detail, amount}] */
      function linesFor(day) {
        var d = effDuration();
        var out = [];
        var booth = ps.boothVariant(day, d);
        if (!booth) return null;
        out.push({ label: tx('pdp', 'line_booth', 'Myselfie photo booth'), detail: d, amount: booth.price });
        if (hasPrinter) {
          var pv = ps.printerVariant(d, day);
          if (!pv) return null;
          out.push({ label: tx('pdp', 'line_printer', 'Printer'), detail: [choice.printType, d].join(' · '), amount: pv.price });
          var lv = logoVariant(choice.logo, day);
          if (choice.logo !== 'ML' && !lv) return null;
          // one "Logo på print" line with every printer (Myselfie Logo = 0 kr), shown under the printer
          if (lv) out.push({ label: tx('pdp', 'logo_on_print', 'Logo på print'), detail: [choice.printType, logoLabel(choice.logo)].join(' · '), amount: lv.price, sub: true });
          var extra = Math.max(0, Math.round((choice.prints - 400) / 400));
          var roll = extra && ps.rollVariant ? ps.rollVariant(day) : null;
          if (extra && roll) out.push({ label: tx('pdp', 'extra_prints', 'Ekstra prints'), detail: extra + ' × 400', amount: roll.price * extra });
        }
        if (hasMyg) {
          var a = mygAddon();
          var av = a && (ps.addonVariant ? ps.addonVariant(a, day) : a.product.variants[0]);
          if (av) out.push({ label: 'Mygreetings', detail: tx('pdp', 'myg_detail', 'Lydgæstebog'), amount: av.price });
        }
        return out;
      }
      function sum(lines) { return (lines || []).reduce(function (n, l) { return n + l.amount; }, 0); }
      /** Why the date cannot be booked for this package ('' = fine). */
      function problem(iso) {
        if (!iso) return '';
        if (iso < tomorrowIso()) return tx('pdp', 'err_from_tomorrow', 'Vælg en dato fra i morgen.');
        var av = window.myselfie && window.myselfie.availability;
        if (av && av.data && typeof av.isLead === 'function' && av.isLead(iso, [hasPrinter ? 'Printer' : 'Myselfie'])) {
          return tx('pdp', 'lead_problem', 'Vi kan ikke levere så hurtigt – vælg en senere dato.');
        }
        var a = typeof ps.dayAvailability === 'function' ? ps.dayAvailability(iso) : null;
        if (!a) return '';
        var day = longDate(iso);
        if (hasPrinter && a.printer === 'sold_out') return tx('pdp', 'printer_sold_out', 'Printeren er udsolgt [date] – vælg en anden dato.', { date: day });
        if (!hasPrinter && a.myselfie === 'sold_out') return tx('pdp', 'booth_sold_out', 'Myselfie er udsolgt [date] – vælg en anden dato.', { date: day });
        if (hasMyg) {
          var key = mygKey();
          if (key && a.addons && a.addons[key] === 'sold_out') return tx('pdp', 'myg_sold_out', 'Mygreetings er udsolgt [date] – vælg en anden dato.', { date: day });
        }
        return '';
      }
      function statusText(iso) {
        var a = typeof ps.dayAvailability === 'function' ? ps.dayAvailability(iso) : null;
        var st = a ? (hasPrinter ? a.printer : a.myselfie) : 'available';
        var t = st === 'low' ? tx('pdp', 'status_low', 'Få tilbage') : tx('pdp', 'status_available', 'Ledig');
        var d = effDuration();
        if (d !== choice.duration) t = tx('pdp', 'weekend_switched', '[status] · [duration] (weekend-leje gælder fredag–søndag)', { status: t, duration: d.toLowerCase() });
        return { text: t, state: st === 'low' ? 'low' : 'available' };
      }
      function seg(name, label, values, current, priceOf) {
        return '<fieldset class="mys-pdp-bundle__step"><legend class="mys-pdp-bundle__label">' + label + '</legend>' +
          '<div class="mys-pdp-bundle__seg" role="radiogroup" aria-label="' + escHtml(label.replace(/<[^>]+>/g, '')) + '">' +
          values.map(function (v) {
            var on = v.value === current;
            return '<button type="button" role="radio" aria-checked="' + on + '" class="mys-pdp-bundle__opt' + (on ? ' is-on' : '') + '" data-bundle-set="' + name + '" data-value="' + escHtml(v.value) + '">' +
              '<span>' + escHtml(v.label) + '</span>' + (priceOf ? '<small>' + priceOf(v) + '</small>' : '') + '</button>';
          }).join('') + '</div></fieldset>';
      }
      function escHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
      function num(n) { return '<span class="mys-pdp-bundle__num" aria-hidden="true">' + n + '</span>'; }
      function render() {
        var iso = choice.iso;
        // 1 date
        var picking = !iso || choice.picking;
        el.known.hidden = picking;
        el.pick.hidden = !picking;
        if (iso) el.dateText.textContent = longDate(iso);
        el.lock.hidden = !choice.locked;
        el.change.hidden = choice.locked;
        var prob = problem(iso);
        if (iso && !prob) {
          var st = statusText(iso);
          el.status.textContent = st.text;
          el.status.setAttribute('data-state', st.state);
        } else {
          el.status.textContent = prob || (iso ? '' : tx('pdp', 'pick_date_hint', 'Vælg datoen – udsolgte datoer kan ikke vælges.'));
          el.status.setAttribute('data-state', prob ? 'sold_out' : 'hint');
        }
        // 2.. options
        var html = '';
        var n = 2;
        var durs = durations().filter(function (d) { return !isLeaseName(d); });
        if (firstOptionIsDuration() && durs.length > 1) {
          html += seg('duration', num(n++) + escHtml(tx('pdp', 'rental_period', 'Lejeperiode')), durs.map(function (d) {
            return { value: d, label: d };
          }), choice.duration);
        }
        if (hasPrinter) {
          html += seg('printType', num(n++) + escHtml(tx('pdp', 'print_type', 'Print type')), printTypes().map(function (t) { return { value: t, label: t }; }), choice.printType);
          var day = iso || '';
          var logos = ['ML', 'NL', 'EL'].map(function (c) { return { value: c, label: logoLabel(c) }; })
            .filter(function (o) { return o.value === 'ML' || logoVariant(o.value, day); });
          html += seg('logo', num(n++) + escHtml(tx('pdp', 'logo_on_print', 'Logo på print')), logos, choice.logo, function (o) {
            var lv = logoVariant(o.value, day);
            return lv && lv.price ? '+' + escHtml(fmt(lv.price)) : escHtml(tx('pdp', 'free_lc', 'gratis'));
          });
          if (choice.logo === 'EL') html += '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'own_logo_help', 'Eget logo: I lægger logoet ind i galleriet efter bestillingen.')) + '</p>';
          var max = maxPrints();
          var roll = ps.rollVariant ? ps.rollVariant(day) : null;
          html += '<div class="mys-pdp-bundle__step"><p class="mys-pdp-bundle__label" id="pdp-bundle-prints-l">' + num(n++) + escHtml(tx('pdp', 'prints_count', 'Antal prints')) + '</p>' +
            '<div class="mys-pdp__stepper mys-pdp-bundle__stepper" role="group" aria-labelledby="pdp-bundle-prints-l">' +
              '<button type="button" data-bundle-prints="-400" aria-label="' + escHtml(tx('pdp', 'fewer_prints', '400 færre prints')) + '"' + (choice.prints <= 400 ? ' disabled' : '') + '>−</button>' +
              '<output aria-live="polite">' + choice.prints + '</output>' +
              '<button type="button" data-bundle-prints="400" aria-label="' + escHtml(tx('pdp', 'more_prints', '400 flere prints')) + '"' + (choice.prints >= max ? ' disabled' : '') + '>+</button>' +
            '</div>' +
            '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'first_roll_incl', 'Første rulle (400 prints) er inkluderet.')) + (roll ? ' ' + escHtml(tx('pdp', 'extra_rolls', 'Ekstra ruller: [price] pr. 400 prints.', { price: fmt(roll.price) })) : '') + '</p></div>';
        }
        if (hasMyg) html += '<p class="mys-pdp-bundle__incl">' + iconCheck() + escHtml(tx('pdp', 'myg_included', 'Med i pakken: Mygreetings lydgæstebog')) + '</p>';
        if (el.options._html !== html) { el.options._html = html; el.options.innerHTML = html; }
        // summary
        var sumHtml = '';
        if (iso && !prob) {
          var lines = linesFor(iso);
          if (lines) {
            sumHtml = '<ul class="mys-pdp-bundle__lines" role="list">' + lines.map(function (l) {
              if (l.sub) return '<li class="mys-pdp-bundle__sub"><span><small>' + escHtml(l.label + ': ' + l.detail) + '</small></span><span>' + (l.amount ? escHtml(fmt(l.amount)) : escHtml(tx('pdp', 'free', 'Gratis'))) + '</span></li>';
              return '<li><span>' + escHtml(l.label) + (l.detail ? ' <small>' + escHtml(l.detail) + '</small>' : '') + '</span><span>' + escHtml(fmt(l.amount)) + '</span></li>';
            }).join('') + '</ul><p class="mys-pdp-bundle__total"><span>' + escHtml(tx('pdp', 'total_incl_vat', 'I alt inkl. moms')) + '</span><strong data-pdp-bundle-total>' + escHtml(fmt(sum(lines))) + '</strong></p>' +
            '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'price_applies_long', 'Prisen gælder [date].', { date: longDate(iso) })) + '</p>';
          } else sumHtml = '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'bundle_unavailable', 'Pakken kan ikke bookes på denne dato – vælg en anden dato.')) + '</p>';
        } else {
          var span = typeof ps.spanOf === 'function' ? ps.spanOf(function (day) { var ls = linesFor(day); return ls ? sum(ls) : null; }) : null;
          sumHtml = '<p class="mys-pdp-bundle__total"><span>' + escHtml(tx('pdp', 'total_incl_vat', 'I alt inkl. moms')) + '</span><strong data-pdp-bundle-total>' + (span && span.min != null ? escHtml(span.varies ? tx('pdp', 'from_price', 'fra [price]', { price: fmt(span.min) }) : fmt(span.min)) : '–') + '</strong></p>' +
            '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'price_depends', 'Prisen afhænger af datoen.')) + '</p>';
        }
        if (el.summary._html !== sumHtml) { el.summary._html = sumHtml; el.summary.innerHTML = sumHtml; }
        el.confirm.disabled = busy || !iso || !!prob || !linesFor(iso);
        if (!busy) el.confirm.textContent = confirmLabel;
      }
      function iconCheck() { return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'; }
      function showErr(msg) {
        el.err.textContent = msg || '';
        el.err.hidden = !msg;
      }
      function setIso(iso) {
        choice.iso = iso;
        choice.picking = false;
        showErr('');
        render();
      }
      function open(trigger) {
        opener = trigger || null;
        var hero = current || {};
        choice = {
          iso: lockedIso() || (ps.state.iso && ps.state.iso >= tomorrowIso() ? ps.state.iso : '') || storedIso(),
          locked: !!lockedIso(),
          picking: false,
          duration: firstOptionIsDuration() ? durOfVariant(hero) : weekendName(),
          printType: moduleType(printTypeOf(current) || printTypes()[0]),
          logo: logoCodeOf(current) || 'ML',
          prints: wantedPrints(),
        };
        if (choice.iso && problem(choice.iso) && !choice.locked) choice.picking = true; // a remembered date that cannot be booked: ask
        if (el.input) el.input.value = choice.iso ? isoToDisplay(choice.iso) : '';
        busy = false;
        showErr('');
        render();
        dlg.showModal();
        document.documentElement.classList.add('mys-pdp-bundle-open');
        var title = dlg.querySelector('.mys-pdp-bundle__title');
        if (title) { title.setAttribute('tabindex', '-1'); try { title.focus(); } catch (e) { /* ignore */ } }
      }
      function close() {
        if (busy) return;
        if (dlg.open) dlg.close();
      }
      dlg.addEventListener('close', function () {
        document.documentElement.classList.remove('mys-pdp-bundle-open');
        if (opener) { try { opener.focus(); } catch (e) { /* ignore */ } }
      });
      dlg.addEventListener('cancel', function (e) { if (busy) e.preventDefault(); });
      dlg.addEventListener('click', function (e) {
        if (e.target === dlg) return close(); // the backdrop
        var t = e.target.closest ? e.target : null;
        if (!t) return;
        if (t.closest('[data-pdp-bundle-close]')) return close();
        if (t.closest('[data-pdp-bundle-change]')) {
          choice.picking = true;
          render();
          setTimeout(function () { try { el.input.focus(); } catch (err) { /* ignore */ } }, 0);
          return;
        }
        if (t.closest('[data-pdp-bundle-confirm]')) return confirm();
        var setBtn = t.closest('[data-bundle-set]');
        if (setBtn && !busy) {
          choice[setBtn.getAttribute('data-bundle-set')] = setBtn.getAttribute('data-value');
          showErr('');
          render();
          var again = dlg.querySelector('[data-bundle-set="' + setBtn.getAttribute('data-bundle-set') + '"][data-value="' + esc(setBtn.getAttribute('data-value')) + '"]');
          if (again) again.focus();
          return;
        }
        var pr = t.closest('[data-bundle-prints]');
        if (pr && !pr.disabled && !busy) {
          choice.prints = Math.max(400, Math.min(maxPrints(), choice.prints + Number(pr.getAttribute('data-bundle-prints'))));
          render();
          var same = dlg.querySelector('[data-bundle-prints="' + pr.getAttribute('data-bundle-prints') + '"]');
          if (same && !same.disabled) same.focus();
        }
      });
      // the dialog's own date picker: chosen here, applied to the booking (module, cart) only on "Læg i kurv"
      window.addEventListener('myselfie:date', function (e) {
        var d = (e && e.detail) || {};
        if (d.source !== 'bundle') return;
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      }, true);
      if (el.input) {
        el.input.addEventListener('change', function () {
          var iso = displayToIso(el.input.value);
          if (iso && choice) setIso(iso);
        });
      }

      function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
      /** The module's logo button value for a code: '' (Myselfie logo) or the logo variant id it shows. */
      function moduleLogoId(code) {
        return code === 'ML' ? '' : code;
      }
      function cartJs() {
        return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
      }
      async function confirm() {
        if (busy || !choice) return;
        if (!choice.iso) { showErr(tx('pdp', 'pick_date_first', 'Vælg datoen for jeres fest først.')); choice.picking = true; render(); return; }
        var prob = problem(choice.iso);
        if (prob) { showErr(prob); return; }
        if (typeof ps.liveActive !== 'function' || !ps.liveActive()) {
          // the module cannot write the cart live here (e.g. a cart it cannot read): book in the module instead
          busy = false;
          dlg.close();
          gotoHash('#' + (root.getAttribute('data-anchor') || 'book-myselfie'));
          return;
        }
        busy = true;
        showErr('');
        el.confirm.disabled = true;
        el.confirm.textContent = tx('pdp', 'adding_cart', 'Lægger i kurven…');
        presetDone = true; // the confirmed choice wins over the page preset
        touched.printer = true;
        touched.addon = true;
        var display = isoToDisplay(choice.iso);
        try {
          if (ps.state.iso !== choice.iso) {
            document.dispatchEvent(new CustomEvent('myselfie:date', { detail: { iso: choice.iso, display: display, source: 'bundle-confirm' } }));
            try { sessionStorage.setItem('wdn_bookingdate', display); } catch (e) { /* ignore */ }
            await frame();
            await frame();
          }
          var d = effDuration();
          if (ps.state.duration !== d) { click('[data-ps-action="duration"][data-value="' + esc(d) + '"]'); await frame(); }
          if (hasPrinter) {
            if (!ps.state.printer) {
              if (!click('.myselfie-ps__pill[data-ps-action="printer"]')) throw { message: tx('pdp', 'err_printer', 'Printeren kunne ikke vælges på denne dato.') };
              printerOurs = true;
              await frame();
            }
            if (ps.state.printType !== choice.printType) { click('[data-ps-action="print-type"][data-value="' + esc(choice.printType) + '"]'); await frame(); }
            var lid = moduleLogoId(choice.logo);
            if (moduleLogo() !== lid) { click('[data-ps-action="logo"][data-value="' + esc(lid) + '"]'); await frame(); }
            for (var i = 0; i < 10 && ps.state.prints !== choice.prints; i++) {
              if (!click('[data-ps-action="prints"][data-value="' + (ps.state.prints < choice.prints ? '' : '-') + '400"]')) break;
              await frame();
            }
          }
          if (hasMyg) {
            var key = mygKey();
            if (key && !ps.state.addons[key]) {
              if (!click('.myselfie-ps__pill[data-ps-action="addon"][data-value="' + esc(key) + '"]')) throw { message: tx('pdp', 'err_myg', 'Mygreetings kunne ikke vælges på denne dato.') };
              await frame();
            }
          }
          await ps.whenLiveIdle();
          await wait(400);
          await ps.whenLiveIdle();
          if (ps.cartSync && ps.cartSync.error) throw { message: ps.cartSync.error };
          var urgent = (typeof ps.issues === 'function' ? ps.issues() : []).filter(function (x) { return x.urgent; });
          if (urgent.length) throw { message: urgent[0].message };
          var cart = await cartJs();
          var items = cart.items || [];
          var bad = items.some(function (it) { return /\+/.test(String(it.sku || '')); });
          var booth = items.some(function (it) { return /^M-/i.test(String(it.sku || '')) && it.properties && it.properties.Date === display; });
          var printer = !hasPrinter || items.some(function (it) { return /^MYP/i.test(String(it.sku || '')) && it.properties && it.properties.print_mode; });
          var wantLogo = hasPrinter && !!logoVariant(choice.logo, choice.iso);
          var logoOk = !wantLogo || items.filter(function (it) { return /^LOGO-/i.test(String(it.sku || '')); }).length === 1;
          var myg = !hasMyg || items.some(function (it) { return /^MYG/i.test(String(it.sku || '')) && it.properties && it.properties.Date === display; });
          if (bad || !booth || !printer || !myg || !logoOk) throw { message: tx('pdp', 'err_partial', 'Kurven blev ikke opdateret helt. Prøv igen om et øjeblik.') };
          location.href = ROOT + 'cart';
        } catch (err) {
          busy = false;
          showErr((err && err.message && !(err instanceof Error)) ? err.message : tx('pdp', 'err_generic', 'Noget gik galt. Prøv igen om et øjeblik.'));
          render();
        }
      }
      return { open: open };
    })();
    // "Læg i kurv" (hero + sticky bar) opens the dialog once the module is ready; lease months keep their link.
    // Window capture phase: the header (assets/mys-nav.js) handles every #book-myselfie link on the document first.
    window.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-pdp-bundle-cta]');
      if (!a || !root.contains(a) || !bundleUi || isLease(current)) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (ready()) return bundleUi.open(a);
      var l = a.querySelector('[data-pdp-cta-label]');
      var before = l ? l.textContent : '';
      if (l) l.textContent = tx('pdp', 'wait', 'Øjeblik…');
      whenReady().then(function () { if (l) l.textContent = before; bundleUi.open(a); }, function () {
        if (l) l.textContent = before;
        gotoHash('#' + (root.getAttribute('data-anchor') || 'book-myselfie'));
      });
    }, true);

    whenReady().then(function () {
      boothPricer = modulePrice;
      // bundle pages (owner 2026-10-05): the module's own "Gå til betaling" ends on /cart, like the dialog
      if (IS_BUNDLE && ps.cfg && ps.cfg.checkout) {
        ps.cfg.checkout.skipCart = false;
        var book = ps.querySelector('[data-ps-book]');
        var toCart = tx('pdp', 'go_to_cart_arrow', 'Gå til kurven →');
        if (book) { book.setAttribute('data-label', toCart); if (!ps.state.busy) book.textContent = toCart; }
      }
      datedModule = function () { return ps.state && ps.state.iso; };
      // customer clicks in the module (trusted only - our own programmatic clicks are not "touches")
      ps.addEventListener('click', function (e) {
        if (!e.isTrusted) return;
        var t = e.target.closest && e.target.closest('[data-ps-action]');
        if (!t) return;
        var action = t.getAttribute('data-ps-action');
        if (/^(printer|print-type|logo|prints)$/.test(action)) touched.printer = true;
        if (action === 'addon') touched.addon = true;
        if (action === 'duration') setTimeout(function () { pullDuration(true); renderDatePrice(); }, 0);
      }, true);
      ps.addEventListener('click', function () { setTimeout(renderDatePrice, 0); });

      // landing: an explicit ?variant= (Google Shopping, links) sets the module's duration; otherwise the
      // module's remembered duration (e.g. after the price-tier redirect of api-dates.js) shows in the hero
      if (explicit) pushDuration(); else pullDuration(false);

      document.addEventListener('myselfie:date', function () {
        // a Monday-Thursday date switches the module from Weekend to a weekday rental: the hero follows it
        setTimeout(function () { pullDuration(false); applyPreset(); renderDatePrice(); }, 50);
      });
      if (ps.state.iso) applyPreset();
      renderDatePrice();
    }).catch(function () { warn('preset skipped (booking module not ready)'); });

    onVariant(function (v, opts) {
      if (!ready() || opts.fromModule) return;
      if (opts.user) {
        pushDuration();
        if (presetDone && hasPrinter && (printerOurs || ps.state.printer)) syncPrinterOptions().then(renderDatePrice);
      }
      renderDatePrice();
    });
  })();

  /* ---------------------------------------------------------------- season bundles: sold whole (owner 2026-10-08)
     A bundle with its own "Season" option (Myselfie & Mygreetings / Print / Premium: Varighed x Season, SKUs M-W+MYG,
     M-W+MYP, M-W+MYG+MYP) goes into the cart as ONE line - the bundle variant of the date's season (assets/
     myselfie-seasons.js pick, the same calendar as Myselfie) with Date, _reason, _reason_andet and, with a printer,
     print_mode (Polaroid | Strip, read by Myselfie.Orders) - plus the "Logo på print" variant (logo x print type, the
     Myselfie Logo is a 0 kr line) and the extra rolls, as the booking module sells them with a printer. The dialog is the
     old bundles' confirm dialog (same markup); there is no booking module on the page. A booking already in the cart
     (booth, old or season bundle, with its printer / Mygreetings / logo / rolls) is replaced, and other dated lines
     move to the chosen date (one date per order). Then /cart. Hero: the variant price of the date's season, "fra"
     without a date; an incoming ?variant= keeps its own price until a date is known (Google Shopping). */
  (function () {
    if (!IS_WHOLE) return;
    var dlg = root.querySelector('[data-pdp-bundle]');
    var hasPrinter = KIND === 'booth-print' || KIND === 'booth-premium';
    var hasMyg = KIND === 'booth-mygreetings' || KIND === 'booth-premium';
    var product = { options: OPTION_NAMES, variants: variants };
    var cfgW = {};
    try { cfgW = JSON.parse((root.querySelector('[data-pdp-whole-config]') || {}).textContent || '{}'); } catch (e) { cfgW = {}; }
    var COMPONENTS = String(cfgW.components || (hasPrinter ? 'Printer' : 'Myselfie')).split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    // shown print type names of this store ("Polaroid, Fotostribe" / "Polaroid, Fotoremsa"); print_mode is always Polaroid | Strip
    var PRINT_TYPES = tx('pdp', 'print_types', 'Polaroid,Fotostribe').split(',').map(function (x) { return x.trim(); });
    function kit() { return window.myselfie && window.myselfie.checkoutKit; }
    function avail() { return window.myselfie && window.myselfie.availability; }
    function tomorrowIso() { var t = new Date(); t = new Date(t.getFullYear(), t.getMonth(), t.getDate() + 1); return t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate()); }
    function isoToDisplay(iso) { var p = iso.split('-'); return p[2] + '/' + p[1] + '/' + p[0]; }
    function longDate(iso) {
      var p = iso.split('-');
      var d = new Date(+p[0], +p[1] - 1, +p[2]);
      var wd = tx('date', 'weekdays', 'søndag,mandag,tirsdag,onsdag,torsdag,fredag,lørdag').split(',');
      var mo = tx('date', 'months', 'januar,februar,marts,april,maj,juni,juli,august,september,oktober,november,december').split(',');
      var date = tx('date', 'day_month_year', '[day]. [month] [year]', { day: d.getDate(), month: mo[d.getMonth()], year: d.getFullYear() });
      return tx('date', 'weekday_on', '[weekday] d. [date]', { weekday: wd[d.getDay()], date: date });
    }
    function storedIso() {
      var v = '';
      try { v = sessionStorage.getItem('wdn_bookingdate') || ''; } catch (e) { v = ''; }
      var iso = displayToIso(v);
      return iso && iso >= tomorrowIso() ? iso : '';
    }
    function escHtml(x) { return String(x == null ? '' : x).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function sk() { return SK(); }

    /* ----- price: the bundle variant of the date's season ----- */
    var dateIso = (serverIso && serverIso >= tomorrowIso() ? serverIso : '') || storedIso();
    function sameExceptSeason(a, b) { return a.options.every(function (o, i) { return i === SEASON_IDX || o === b.options[i]; }); }
    function variantFor(v, iso) {
      var k = sk();
      if (!k || !v) return v;
      var others = {};
      v.options.forEach(function (o, i) { if (i !== SEASON_IDX) others[i] = o; });
      return k.pick(product, { others: others, iso: iso || '' }) || v;
    }
    boothPricer = function (v) {
      if (!v || isLease(v)) return null;
      var iso = dateIso && dateIso >= tomorrowIso() ? dateIso : '';
      if (iso) {
        var x = variantFor(v, iso);
        return x ? { amount: x.price, mode: 'exact', iso: iso } : null;
      }
      var min = null;
      var max = null;
      variants.forEach(function (x) {
        if (!sameExceptSeason(x, v)) return;
        if (min === null || x.price < min) min = x.price;
        if (max === null || x.price > max) max = x.price;
      });
      return min === null ? null : { amount: min, mode: max > min ? 'from' : 'plain' };
    };
    datedModule = function () { return dateIso; };
    /** The hero's variant is the one of the date's season (default season without a date), as on Myselfie. */
    function follow() {
      if (current && !(LANDING_ID && String(current.id) === LANDING_ID && !dateIso)) {
        var v = variantFor(current, dateIso);
        if (v && v.id !== current.id) { renderVariant(v, { push: false, user: false, fromModule: true }); return; }
      }
      renderPrice();
    }
    document.addEventListener('myselfie:date', function (e) {
      var d = (e && e.detail) || {};
      if (d.source === 'bundle') return;
      if (d.cleared) dateIso = '';
      else if (d.iso && d.iso >= tomorrowIso()) dateIso = d.iso;
      else return;
      follow();
    });
    // the season calendar (footer section) and the season kit (deferred) are there after DOMContentLoaded
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', follow);
    else follow();

    if (!dlg || typeof dlg.showModal !== 'function') return;
    var $b = function (sel) { return dlg.querySelector(sel); };
    var el = {
      known: $b('[data-pdp-bundle-known]'), pick: $b('[data-pdp-bundle-pick]'), dateText: $b('[data-pdp-bundle-date-text]'),
      lock: $b('[data-pdp-bundle-lock]'), change: $b('[data-pdp-bundle-change]'), input: $b('[data-pdp-bundle-date]'),
      status: $b('[data-pdp-bundle-status]'), options: $b('[data-pdp-bundle-options]'), summary: $b('[data-pdp-bundle-summary]'),
      err: $b('[data-pdp-bundle-err]'), confirm: $b('[data-pdp-bundle-confirm]'),
    };
    var confirmLabel = el.confirm ? el.confirm.textContent : '';
    var choice = null;
    var busy = false;
    var opener = null;
    var cart = null; // /cart.js since the dialog opened

    /* ----- what the cart holds ----- */
    function cameraType() {
      var M = window.myselfie || {};
      return (M.cartRules && M.cartRules.cameraType) || (M.orderRule && M.orderRule.cameraType) || 'Myselfie';
    }
    function freePropsId() { var M = window.myselfie || {}; return M.cartRules && M.cartRules.freeProps; }
    function isAuto(it) {
      if (freePropsId() && it.variant_id === freePropsId()) return true;
      return Object.keys(it.properties || {}).some(function (k) { return k.indexOf('__upcart') === 0; });
    }
    function isCamera(it) { return !isAuto(it) && it.product_type === cameraType(); }
    function inProduct(p, it) { return !!p && !!p.variants && p.variants.some(function (v) { return v.id === it.variant_id; }); }
    function sku(it) { return String(it.sku || '').trim().toUpperCase(); }
    function isLogoLine(it) { return inProduct(cfgW.logo, it) || /^LOGO-/.test(sku(it)); }
    function isRollLine(it) { return inProduct(cfgW.roll, it) || /^XPR/.test(sku(it)); }
    function isPrinterLine(it) { return !isCamera(it) && /^(MYP|QP)/.test(sku(it)); }
    function hasPrinterPart(it) { return /(^|\+)MYP/.test(sku(it)); }
    /** {remove, keep, cameraQty, booth (first camera line), mine (this product's line)} - what "Læg i kurv" replaces */
    function plan(c) {
      var items = (c && c.items) || [];
      var cams = items.filter(isCamera);
      var standalonePrinter = items.some(isPrinterLine);
      var printExtras = hasPrinter || (cams.some(hasPrinterPart) && !standalonePrinter);
      var remove = items.filter(function (it) {
        if (isAuto(it)) return false;
        if (isCamera(it)) return true;
        if (hasPrinter && isPrinterLine(it)) return true;
        if (hasMyg && /^MYG/.test(sku(it))) return true;
        if (printExtras && (isLogoLine(it) || isRollLine(it))) return true;
        return false;
      });
      var handle = root.getAttribute('data-handle');
      return {
        remove: remove,
        keep: items.filter(function (it) { return remove.indexOf(it) < 0 && !isAuto(it); }),
        cameraQty: cams.reduce(function (n, it) { return n + it.quantity; }, 0),
        booth: cams[0] || null,
        mine: cams.filter(function (it) { return it.handle === handle; })[0] || null,
      };
    }
    function cartGet() {
      var K = kit();
      if (K && K.cartGet) return K.cartGet();
      return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
    }
    function cartPost(path, body) {
      var K = kit();
      if (K && K.cartPost) return K.cartPost(path, body);
      return fetch(ROOT + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json().then(function (b) { if (!r.ok) throw { status: r.status, message: b.description || b.message }; return b; }); });
    }

    /* ----- options ----- */
    function durations() {
      var out = [];
      variants.forEach(function (v) {
        var d = durOfVariant(v);
        if (d && out.indexOf(d) < 0 && !isLeaseName(d)) out.push(d);
      });
      return out;
    }
    /** Weekend rentals are Friday-Sunday: a Monday-Thursday date is a weekday rental (as the booking module).
        Duration codes from the SKUs (M-W = weekend, M-1 = 1 weekday), so it works with every store's option values. */
    function effDuration() {
      var d = choice.duration || durations()[0] || weekendName();
      if (choice.iso && durCode(d) === 'W') {
        var wd = new Date(+choice.iso.slice(0, 4), +choice.iso.slice(5, 7) - 1, +choice.iso.slice(8, 10)).getDay();
        if (wd >= 1 && wd <= 4) {
          var list = durations();
          for (var i = 0; i < list.length; i++) if (durCode(list[i]) === '1') return list[i];
        }
      }
      return d;
    }
    /** The bundle variant for a day ('' = no date: the default season) and the chosen period. */
    function bundleVariant(day, duration) {
      var k = sk();
      var want = { duration: duration || effDuration(), iso: day || '', strict: true };
      if (k) return k.pick(product, want);
      return variants.filter(function (v) { return durOfVariant(v) === want.duration; })[0] || null;
    }
    function logoVariant(code, day) {
      var K = kit();
      return cfgW.logo && K && K.pickLogo ? K.pickLogo(cfgW.logo, code || 'ML', choice.printType, day || '') : null;
    }
    function logoLabel(code) {
      var K = kit();
      return cfgW.logo && K && K.logoName ? K.logoName(cfgW.logo, code) : ({ ML: tx('pdp', 'logo_ml', 'Myselfie Logo'), NL: tx('pdp', 'logo_nl', 'Ingen logo'), EL: tx('pdp', 'logo_el', 'Eget logo') })[code];
    }
    function rollVariant(day) {
      var r = cfgW.roll;
      if (!r || !r.variants || !r.variants.length) return null;
      var k = sk();
      return (k ? k.pick(r, { iso: day || '' }) : null) || r.variants[0];
    }
    function maxPrints() { return rollVariant('') ? 400 + 400 * (Number(cfgW.maxRolls) || 5) : 400; }
    function extraRolls() { return Math.max(0, Math.round((choice.prints - 400) / 400)); }
    /** Cheapest season of a rental period. */
    function minPrice(d) {
      var min = null;
      variants.forEach(function (v) { if (durOfVariant(v) === d && (min === null || v.price < min)) min = v.price; });
      return min;
    }
    /** [{label, detail, amount, sub, variant, qty}] for a day, or null when the package cannot be sold then. */
    function linesFor(day) {
      var bv = bundleVariant(day);
      if (!bv) return null;
      var d = effDuration();
      var title = ((root.querySelector('#pdp-title') || {}).textContent || tx('pdp', 'the_package', 'Pakken')).trim();
      var out = [{ label: title, detail: hasPrinter ? [d, choice.printType, tx('pdp', 'n_prints', '[n] prints', { n: 400 })].join(' · ') : d, amount: bv.price, variant: bv }];
      if (hasPrinter) {
        var lv = logoVariant(choice.logo, day);
        if (!lv && choice.logo !== 'ML') return null;
        if (lv) out.push({ label: tx('pdp', 'logo_on_print', 'Logo på print'), detail: [choice.printType, logoLabel(choice.logo)].join(' · '), amount: lv.price, sub: true, variant: lv });
        var extra = extraRolls();
        var rv = extra ? rollVariant(day) : null;
        if (extra && rv) out.push({ label: tx('pdp', 'extra_prints', 'Ekstra prints'), detail: extra + ' × 400', amount: rv.price * extra, variant: rv, qty: extra });
      }
      return out;
    }
    function sum(lines) { return (lines || []).reduce(function (n, l) { return n + l.amount; }, 0); }
    function problem(iso) {
      if (!iso) return '';
      if (iso < tomorrowIso()) return tx('pdp', 'err_from_tomorrow', 'Vælg en dato fra i morgen.');
      var a = avail();
      var day = longDate(iso);
      if (a && a.data && typeof a.isLead === 'function' && a.isLead(iso, COMPONENTS)) return tx('pdp', 'lead_problem', 'Vi kan ikke levere så hurtigt – vælg en senere dato.');
      if (a && a.data) {
        if (hasPrinter && a.statusFor(iso, ['Printer']) === 'sold_out') return tx('pdp', 'printer_sold_out', 'Printeren er udsolgt [date] – vælg en anden dato.', { date: day });
        if (!hasPrinter && a.statusFor(iso, ['Myselfie']) === 'sold_out') return tx('pdp', 'booth_sold_out', 'Myselfie er udsolgt [date] – vælg en anden dato.', { date: day });
        if (hasMyg && a.statusFor(iso, ['Mygreetings']) === 'sold_out') return tx('pdp', 'myg_sold_out', 'Mygreetings er udsolgt [date] – vælg en anden dato.', { date: day });
      }
      var bv = bundleVariant(iso);
      if (!bv) return tx('pdp', 'whole_no_duration', 'Pakken findes ikke som [duration].', { duration: effDuration().toLowerCase() });
      if (bv.available === false) return tx('pdp', 'whole_sold_out_duration', 'Pakken er udsolgt som [duration] – vælg en anden lejeperiode.', { duration: effDuration().toLowerCase() });
      return '';
    }
    function statusText(iso) {
      var a = avail();
      var st = a && a.data ? a.statusFor(iso, COMPONENTS) : 'available';
      var t = st === 'low' ? tx('pdp', 'status_low', 'Få tilbage') : tx('pdp', 'status_available', 'Ledig');
      var d = effDuration();
      if (d !== choice.duration) t = tx('pdp', 'weekend_switched', '[status] · [duration] (weekend-leje gælder fredag–søndag)', { status: t, duration: d.toLowerCase() });
      return { text: t, state: st === 'low' ? 'low' : 'available' };
    }
    function seg(name, label, values, on, priceOf) {
      return '<fieldset class="mys-pdp-bundle__step"><legend class="mys-pdp-bundle__label">' + label + '</legend>' +
        '<div class="mys-pdp-bundle__seg" role="radiogroup" aria-label="' + escHtml(label.replace(/<[^>]+>/g, '')) + '">' +
        values.map(function (v) {
          var is = v.value === on;
          var price = priceOf ? priceOf(v) : '';
          return '<button type="button" role="radio" aria-checked="' + is + '" class="mys-pdp-bundle__opt' + (is ? ' is-on' : '') + '" data-bundle-set="' + name + '" data-value="' + escHtml(v.value) + '">' +
            '<span>' + escHtml(v.label) + '</span>' + (price ? '<small>' + price + '</small>' : '') + '</button>';
        }).join('') + '</div></fieldset>';
    }
    function num(n) { return '<span class="mys-pdp-bundle__num" aria-hidden="true">' + n + '</span>'; }
    function iconCheck() { return '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>'; }
    function render() {
      var iso = choice.iso;
      var picking = !iso || choice.picking;
      el.known.hidden = picking;
      el.pick.hidden = !picking;
      if (iso) el.dateText.textContent = longDate(iso);
      el.lock.hidden = true;
      el.change.hidden = false;
      var prob = problem(iso);
      if (iso && !prob) {
        var st = statusText(iso);
        el.status.textContent = st.text;
        el.status.setAttribute('data-state', st.state);
      } else {
        el.status.textContent = prob || (iso ? '' : tx('pdp', 'pick_date_hint', 'Vælg datoen – udsolgte datoer kan ikke vælges.'));
        el.status.setAttribute('data-state', prob ? 'sold_out' : 'hint');
      }
      var day = iso && !prob ? iso : '';
      var html = '';
      var n = 2;
      var durs = durations();
      if (durs.length > 1) {
        html += seg('duration', num(n++) + escHtml(tx('pdp', 'rental_period', 'Lejeperiode')), durs.map(function (d) { return { value: d, label: d }; }), choice.duration, function (o) {
          if (!day) { var m = minPrice(o.value); return m == null ? '' : escHtml(tx('pdp', 'from_price', 'fra [price]', { price: fmt(m) })); }
          var bv = bundleVariant(day, o.value);
          return bv ? escHtml(fmt(bv.price)) : '';
        });
      }
      if (hasPrinter) {
        html += seg('printType', num(n++) + escHtml(tx('pdp', 'print_type', 'Print type')), PRINT_TYPES.map(function (t) { return { value: t, label: t }; }), choice.printType);
        var logos = ['ML', 'NL', 'EL'].map(function (c) { return { value: c, label: logoLabel(c) }; })
          .filter(function (o) { var lv = logoVariant(o.value, day); return o.value === 'ML' || (lv && lv.available !== false); });
        html += seg('logo', num(n++) + escHtml(tx('pdp', 'logo_on_print', 'Logo på print')), logos, choice.logo, function (o) {
          var lv = logoVariant(o.value, day);
          return lv && lv.price ? '+' + escHtml(fmt(lv.price)) : escHtml(tx('pdp', 'free_lc', 'gratis'));
        });
        if (choice.logo === 'EL') html += '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'own_logo_help', 'Eget logo: I lægger logoet ind i galleriet efter bestillingen.')) + '</p>';
        var max = maxPrints();
        var roll = rollVariant(day);
        html += '<div class="mys-pdp-bundle__step"><p class="mys-pdp-bundle__label" id="pdp-bundle-prints-l">' + num(n++) + escHtml(tx('pdp', 'prints_count', 'Antal prints')) + '</p>' +
          '<div class="mys-pdp__stepper mys-pdp-bundle__stepper" role="group" aria-labelledby="pdp-bundle-prints-l">' +
            '<button type="button" data-bundle-prints="-400" aria-label="' + escHtml(tx('pdp', 'fewer_prints', '400 færre prints')) + '"' + (choice.prints <= 400 ? ' disabled' : '') + '>−</button>' +
            '<output aria-live="polite">' + choice.prints + '</output>' +
            '<button type="button" data-bundle-prints="400" aria-label="' + escHtml(tx('pdp', 'more_prints', '400 flere prints')) + '"' + (choice.prints >= max ? ' disabled' : '') + '>+</button>' +
          '</div>' +
          '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'whole_prints_incl', '400 prints er inkluderet i pakken.')) + (roll ? ' ' + escHtml(tx('pdp', 'extra_rolls', 'Ekstra ruller: [price] pr. 400 prints.', { price: fmt(roll.price) })) : '') + '</p></div>';
      }
      if (hasMyg) html += '<p class="mys-pdp-bundle__incl">' + iconCheck() + escHtml(tx('pdp', 'myg_included', 'Med i pakken: Mygreetings lydgæstebog')) + '</p>';
      if (el.options._html !== html) { el.options._html = html; el.options.innerHTML = html; }
      var p = plan(cart);
      var moving = p.keep.some(function (it) { return it.properties && it.properties.Date; });
      var replaceTitle = p.booth ? p.booth.product_title : tx('pdp', 'whole_your_booth', 'Jeres Myselfie');
      var replaceNote = p.cameraQty ? '<p class="mys-pdp-bundle__help">' + escHtml(moving
        ? tx('pdp', 'whole_replace_move', '[title] i kurven bliver erstattet af pakken, og de andre varer følger datoen.', { title: replaceTitle })
        : tx('pdp', 'whole_replace', '[title] i kurven bliver erstattet af pakken.', { title: replaceTitle })) + '</p>' : '';
      var sumHtml = '';
      if (day) {
        var lines = linesFor(day);
        if (lines) {
          sumHtml = '<ul class="mys-pdp-bundle__lines" role="list">' + lines.map(function (l) {
            if (l.sub) return '<li class="mys-pdp-bundle__sub"><span><small>' + escHtml(l.label + ': ' + l.detail) + '</small></span><span>' + (l.amount ? escHtml(fmt(l.amount)) : escHtml(tx('pdp', 'free', 'Gratis'))) + '</span></li>';
            return '<li><span>' + escHtml(l.label) + (l.detail ? ' <small>' + escHtml(l.detail) + '</small>' : '') + '</span><span>' + escHtml(fmt(l.amount)) + '</span></li>';
          }).join('') + '</ul><p class="mys-pdp-bundle__total"><span>' + escHtml(tx('pdp', 'total_incl_vat', 'I alt inkl. moms')) + '</span><strong data-pdp-bundle-total>' + escHtml(fmt(sum(lines))) + '</strong></p>' +
          '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'price_applies_long', 'Prisen gælder [date].', { date: longDate(day) })) + '</p>' + replaceNote;
        } else sumHtml = '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'bundle_unavailable', 'Pakken kan ikke bookes på denne dato – vælg en anden dato.')) + '</p>';
      } else {
        var lo = minPrice(effDuration());
        var extras = 0;
        if (hasPrinter) {
          var lv0 = logoVariant(choice.logo, '');
          if (lv0) extras += lv0.price;
          var rv0 = extraRolls() ? rollVariant('') : null;
          if (rv0) extras += rv0.price * extraRolls();
        }
        sumHtml = '<p class="mys-pdp-bundle__total"><span>' + escHtml(tx('pdp', 'total_incl_vat', 'I alt inkl. moms')) + '</span><strong data-pdp-bundle-total>' + (lo != null ? escHtml(tx('pdp', 'from_price', 'fra [price]', { price: fmt(lo + extras) })) : '–') + '</strong></p>' +
          '<p class="mys-pdp-bundle__help">' + escHtml(tx('pdp', 'price_depends', 'Prisen afhænger af datoen.')) + '</p>' + replaceNote;
      }
      if (el.summary._html !== sumHtml) { el.summary._html = sumHtml; el.summary.innerHTML = sumHtml; }
      el.confirm.disabled = busy || !iso || !!prob || !linesFor(iso);
      if (!busy) el.confirm.textContent = confirmLabel;
    }
    function showErr(msg) {
      el.err.textContent = msg || '';
      el.err.hidden = !msg;
    }
    /** Pre-fill from the cart: its booking date, and this package's choices when it is in the cart ("Ret dato/pakke"). */
    function fromCart(c) {
      var p = plan(c);
      var bIso = p.booth && p.booth.properties ? displayToIso(p.booth.properties.Date) : '';
      if (bIso && bIso >= tomorrowIso()) choice.iso = bIso;
      var mine = p.mine;
      if (!mine) return;
      var k = sk();
      (mine.options_with_values || []).forEach(function (o) {
        if (k && k.isSeasonName(o.name)) return;
        if (durations().indexOf(o.value) > -1) choice.duration = o.value; // the rental period, whatever the option is called
      });
      if (!hasPrinter) return;
      var mode = mine.properties && mine.properties.print_mode;
      if (mode) choice.printType = printKeyOf(mode) === 'S' ? (PRINT_TYPES[1] || PRINT_TYPES[0]) : PRINT_TYPES[0];
      var items = (c && c.items) || [];
      var logo = items.filter(isLogoLine)[0];
      var K = kit();
      var lv = logo && cfgW.logo ? cfgW.logo.variants.filter(function (v) { return v.id === logo.variant_id; })[0] : null;
      var m = logo ? /^LOGO-(EL|NL|ML)/.exec(sku(logo)) : null;
      var code = lv && K && K.logoCode ? K.logoCode(lv, cfgW.logo) : m ? m[1] : '';
      if (code) choice.logo = code;
      var rolls = items.filter(isRollLine).reduce(function (n, it) { return n + it.quantity; }, 0);
      choice.prints = Math.min(maxPrints(), 400 + 400 * rolls);
    }
    function open(trigger) {
      opener = trigger || null;
      var hero = current || variants[0] || { options: [] };
      choice = {
        iso: (dateIso && dateIso >= tomorrowIso() ? dateIso : '') || storedIso(),
        picking: false,
        duration: durOfVariant(hero),
        printType: PRINT_TYPES[0],
        logo: 'ML',
        prints: 400,
      };
      if (durations().indexOf(choice.duration) < 0) choice.duration = durations()[0] || weekendName();
      if (el.input) el.input.value = choice.iso ? isoToDisplay(choice.iso) : '';
      busy = false;
      showErr('');
      render();
      dlg.showModal();
      document.documentElement.classList.add('mys-pdp-bundle-open');
      var title = dlg.querySelector('.mys-pdp-bundle__title');
      if (title) { title.setAttribute('tabindex', '-1'); try { title.focus(); } catch (e) { /* ignore */ } }
      var a = avail();
      if (a && typeof a.load === 'function') a.load().then(function () { if (dlg.open && !busy) render(); });
      cartGet().then(function (c) {
        cart = c;
        if (!dlg.open || busy) return;
        fromCart(c);
        if (choice.iso && problem(choice.iso)) choice.picking = true; // a remembered date that cannot be booked: ask
        if (el.input) el.input.value = choice.iso ? isoToDisplay(choice.iso) : '';
        render();
      }, function () { /* "Læg i kurv" reads the cart again */ });
    }
    function close() {
      if (busy) return;
      if (dlg.open) dlg.close();
    }
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('mys-pdp-bundle-open');
      if (opener) { try { opener.focus(); } catch (e) { /* ignore */ } }
    });
    dlg.addEventListener('cancel', function (e) { if (busy) e.preventDefault(); });
    dlg.addEventListener('click', function (e) {
      if (!choice) return;
      if (e.target === dlg) return close(); // the backdrop
      var t = e.target.closest ? e.target : null;
      if (!t) return;
      if (t.closest('[data-pdp-bundle-close]')) return close();
      if (t.closest('[data-pdp-bundle-change]')) {
        choice.picking = true;
        render();
        setTimeout(function () { try { el.input.focus(); } catch (err) { /* ignore */ } }, 0);
        return;
      }
      if (t.closest('[data-pdp-bundle-confirm]')) return confirm();
      var setBtn = t.closest('[data-bundle-set]');
      if (setBtn && !busy) {
        var name = setBtn.getAttribute('data-bundle-set');
        var value = setBtn.getAttribute('data-value');
        choice[name] = value;
        showErr('');
        render();
        var btns = dlg.querySelectorAll('[data-bundle-set="' + name + '"]');
        for (var i = 0; i < btns.length; i++) if (btns[i].getAttribute('data-value') === value) btns[i].focus();
        // the hero follows the package's rental period
        if (name === 'duration' && current) {
          var hv = resolve(DUR_IDX > -1 ? DUR_IDX : 0, value, current);
          if (hv && hv.id !== current.id) renderVariant(variantFor(hv, dateIso) || hv, { push: false, user: true });
        }
        return;
      }
      var pr = t.closest('[data-bundle-prints]');
      if (pr && !pr.disabled && !busy) {
        choice.prints = Math.max(400, Math.min(maxPrints(), choice.prints + Number(pr.getAttribute('data-bundle-prints'))));
        render();
        var same = dlg.querySelector('[data-bundle-prints="' + pr.getAttribute('data-bundle-prints') + '"]');
        if (same && !same.disabled) same.focus();
      }
    });
    // the dialog's own date picker: chosen here, applied to the booking (header, cart) only on "Læg i kurv"
    window.addEventListener('myselfie:date', function (e) {
      var d = (e && e.detail) || {};
      if (d.source !== 'bundle') return;
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }, true);
    if (el.input) {
      el.input.addEventListener('change', function () {
        var iso = displayToIso(el.input.value);
        if (iso && choice) {
          choice.iso = iso;
          choice.picking = false;
          showErr('');
          render();
        }
      });
    }

    function snapshot(r) {
      var x = { id: r.variant_id, quantity: r.quantity };
      var rp = {};
      Object.keys(r.properties || {}).forEach(function (k) { if (k.indexOf('__') !== 0) rp[k] = r.properties[k]; });
      if (Object.keys(rp).length) x.properties = rp;
      return x;
    }
    async function confirm() {
      if (busy || !choice) return;
      if (!choice.iso) { showErr(tx('pdp', 'pick_date_first', 'Vælg datoen for jeres fest først.')); choice.picking = true; render(); return; }
      var prob = problem(choice.iso);
      if (prob) { showErr(prob); return; }
      busy = true;
      showErr('');
      el.confirm.disabled = true;
      el.confirm.textContent = tx('pdp', 'adding_cart', 'Lægger i kurven…');
      var display = isoToDisplay(choice.iso);
      var removed = [];
      var K = kit();
      var ADD = (K && K.QUIET_ADD) || 'cart/add.js';
      try {
        var c = await cartGet();
        cart = c;
        var p = plan(c);
        if (p.cameraQty > 1) throw { message: tx('pdp', 'whole_multi_booth', 'Kurven har flere Myselfie-bookinger. Ret dem i kurven først.') };
        var lines = linesFor(choice.iso);
        if (!lines) throw { message: tx('pdp', 'bundle_unavailable', 'Pakken kan ikke bookes på denne dato – vælg en anden dato.') };
        var old = (p.booth && p.booth.properties) || {};
        var props = { Date: display };
        if (hasPrinter) props.print_mode = (K && K.printModeOf ? K.printModeOf(choice.printType) : '') || (printKeyOf(choice.printType) === 'S' ? 'Strip' : 'Polaroid');
        props._reason = old._reason || '';
        props._reason_andet = old._reason_andet || '';
        var bv = lines[0].variant;
        if (K && K.withPrintInfo) props = K.withPrintInfo(props, bv.sku);
        var adds = [{ id: bv.id, quantity: 1, properties: props }];
        lines.slice(1).forEach(function (l) {
          var x = { id: l.variant.id, quantity: l.qty || 1 };
          var lp = K && K.withPrintInfo ? K.withPrintInfo(null, l.variant.sku) : null;
          if (lp && Object.keys(lp).length) x.properties = lp;
          adds.push(x);
        });
        // the booking that is replaced goes first (an identical line would otherwise merge with the new one)
        for (var i = 0; i < p.remove.length; i++) {
          await cartPost('cart/change.js', { id: p.remove[i].key, quantity: 0 });
          removed.push(p.remove[i]);
        }
        try {
          await cartPost(ADD, { items: adds });
        } catch (addErr) {
          if (removed.length) await cartPost(ADD, { items: removed.map(snapshot) }).catch(noop); // the old booking back
          throw { message: addErr && addErr.status === 422 && addErr.message ? addErr.message : tx('pdp', 'whole_add_failed', 'Pakken kunne ikke lægges i kurven. Prøv igen om et øjeblik.') };
        }
        // one date per order: the other dated lines follow the package's date
        var fresh = await cartGet();
        var moves = (fresh.items || []).filter(function (it) {
          var d = it.properties && it.properties.Date;
          return d && d !== display && displayToIso(d) && !isCamera(it);
        });
        for (var j = 0; j < moves.length; j++) {
          var mp = {};
          Object.keys(moves[j].properties || {}).forEach(function (k) { mp[k] = moves[j].properties[k]; });
          mp.Date = display;
          await cartPost('cart/change.js', { id: moves[j].key, quantity: moves[j].quantity, properties: mp }).catch(noop);
        }
        try { sessionStorage.setItem('wdn_bookingdate', display); } catch (e) { /* ignore */ }
        try { document.dispatchEvent(new CustomEvent('myselfie:date', { detail: { iso: choice.iso, display: display, source: 'bundle-confirm' } })); } catch (e) { /* ignore */ }
        var done = await cartGet().catch(function () { return null; });
        if (done) { try { document.dispatchEvent(new CustomEvent('myselfie:cart', { detail: cartDetail(done) })); } catch (e) { /* ignore */ } }
        location.href = ROOT + 'cart';
      } catch (err) {
        busy = false;
        cartGet().then(function (c2) { cart = c2; if (dlg.open) render(); }, noop);
        showErr((err && err.message && !(err instanceof Error)) ? err.message : tx('pdp', 'err_generic', 'Noget gik galt. Prøv igen om et øjeblik.'));
        render();
      }
    }

    // "Læg i kurv" (hero + sticky bar) opens the dialog. Window capture phase: before assets/mys-nav.js.
    window.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-pdp-bundle-cta]');
      if (!a || !root.contains(a) || isLease(current)) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      open(a);
    }, true);
  })();

  /* ---------------------------------------------------------------- related: quick add (mys-rek-card forms) */
  all('[data-pdp-related] form[data-rek-add]').forEach(function (f) {
    var btn = f.querySelector('button[type="submit"]');
    var lab = f.querySelector('[data-rek-label]');
    var err = f.querySelector('[data-rek-err]');
    var section = f.closest('[data-pdp-related]');
    var st = section && section.querySelector('[data-rek-status]');
    var original = lab ? lab.textContent : '';
    f.addEventListener('submit', function (e) {
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      if (!btn || btn.getAttribute('aria-busy') === 'true') return;
      if (err) { err.hidden = true; err.textContent = ''; }
      addForm(f, {
        busy: function (on) {
          if (on) { btn.setAttribute('aria-busy', 'true'); if (lab) lab.textContent = tx('pdp', 'adding', 'Lægger i kurv…'); }
          else btn.removeAttribute('aria-busy');
        },
        done: function () {
          btn.classList.add('is-added');
          if (lab) lab.textContent = tx('pdp', 'added', '✓ Lagt i kurven');
          var card = f.closest('.mys-rek-card');
          var t = card && card.querySelector('.mys-rek-card__title');
          if (st) st.textContent = tx('pdp', 'added_status', '»[title]« er lagt i kurven.', { title: t ? t.textContent.trim() : tx('pdp', 'the_item', 'Varen') });
        },
        error: function (msg) {
          if (lab) lab.textContent = original;
          if (err) { err.textContent = msg; err.hidden = false; }
        },
      });
    });
  });

  /* ---------------------------------------------------------------- about: "Læs mere" */
  all('[data-pdp-about]').forEach(function (box) {
    if (!box.classList.contains('is-collapsible')) return;
    var btn = box.parentNode.querySelector('[data-pdp-about-toggle]');
    if (!btn || box.scrollHeight < 420) return;
    var lab = btn.querySelector('[data-pdp-about-label]');
    box.classList.add('is-collapsed');
    btn.hidden = false;
    btn.addEventListener('click', function () {
      var open = box.classList.toggle('is-collapsed') === false;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (lab) lab.textContent = open ? tx('pdp', 'show_less', 'Vis mindre') : tx('pdp', 'read_more', 'Læs mere');
      if (!open) scrollToEl(box.closest('section') || box);
    });
  });
})();
